import { all, call, cancelled, delay, put, race, select, take, takeLatest } from 'redux-saga/effects';
import { campaignReportWatchers } from './campaignReportSaga';
import influencerPrelinkSaga from './influencerPrelinkSaga';
import {
    joinProgramSuccess,
    joinProgramFail,
    createOffsiteCampaignSuccess,
    createOffsiteCampaignFail,
    requestToJoinCampaignSuccess,
    requestToJoinCampaignFail,
    approveCampaignJoinRequestSuccess,
    approveCampaignJoinRequestFail,
    bulkApproveCampaignJoinRequestsSuccess,
    bulkApproveCampaignJoinRequestsFail,
    bulkRejectCampaignJoinRequestsSuccess,
    bulkRejectCampaignJoinRequestsFail,
    bulkRescindCampaignParticipantsSuccess,
    bulkRescindCampaignParticipantsFail,
    rejectCampaignJoinRequestSuccess,
    rejectCampaignJoinRequestFail,
    getCampaignPendingInvitesSuccess,
    getCampaignPendingInvitesFail,
    cancelCampaignInviteSuccess,
    cancelCampaignInviteFail,
    rescindCampaignParticipantApprovalSuccess,
    rescindCampaignParticipantApprovalFail,
    getOffsiteCampaignDetailsSuccess,
    getOffsiteCampaignDetailsFail,
    getCampaignJobDetailsSuccess,
    getCampaignJobDetailsFail,
    getCampaignApplicationReviewSuccess,
    getCampaignApplicationReviewFail,
    getCampaignWorkspace,
    getCampaignWorkspaceSuccess,
    getCampaignWorkspaceFail,
    clearCampaignWorkspace,
    saveBrandReviewSuccess,
    saveBrandReviewFail,
    fetchBrandReviewsPageSuccess,
    fetchBrandReviewsPageFail,
    saveInfluencerReviewSuccess,
    saveInfluencerReviewFail,
    submitParticipantWorkSuccess,
    submitParticipantWorkFail,
    sendCampaignThreadMessageSuccess,
    sendCampaignThreadMessageFail,
    broadcastCampaignParticipantMessageSuccess,
    broadcastCampaignParticipantMessageFail,
    listCampaignThreadMessagesSuccess,
    listCampaignThreadMessagesFail,
    patchCampaignThreadMessageSuccess,
    patchCampaignThreadMessageFail,
    deleteCampaignThreadMessageSuccess,
    deleteCampaignThreadMessageFail,
    markCampaignThreadReadSuccess,
    markCampaignThreadReadFail,
    markAllCampaignThreadsReadSuccess,
    markAllCampaignThreadsReadFail,
    manageOffsiteCampaignsSuccess,
    manageOffsiteCampaignsFail,
    updateOffsiteCampaignSuccess,
    updateOffsiteCampaignFail,
    updateCampaignStatusSuccess,
    updateCampaignStatusFail,
    deleteOffsiteCampaignSuccess,
    deleteOffsiteCampaignFail,
    getBrandsSuccess,
    getBrandsFail,
    getBrandSuccess,
    getBrandFail,
    addBrandSuccess,
    addBrandFail,
    updateBrandSuccess,
    updateBrandFail,
    deleteBrandSuccess,
    deleteBrandFail,
    requestDeliverableUpdateSuccess,
    requestDeliverableUpdateFail,
    bulkRequestRevisionSuccess,
    bulkRequestRevisionFail,
    relaunchCampaignSuccess,
    relaunchCampaignFail,
    sendCampaignMessageSuccess,
    sendCampaignMessageFail,
    deleteCampaignMessageSuccess,
    deleteCampaignMessageFail,
    updateCampaignMessageSuccess,
    updateCampaignMessageFail,
    approveDeliverableSubmissionSuccess,
    approveDeliverableSubmissionFail,
    schedulePostSuccess,
    schedulePostFail,
    uploadDeliverableSuccess,
    uploadDeliverableFail,
    getBuzzBridgeProfileSuccess,
    getBuzzBridgeProfileFail,
    getBuzzBridgeProfileNoInfluencer,
    getPublicInfluencerProfileSuccess,
    getPublicInfluencerProfileFail,
    updateBuzzBridgeProfileSuccess,
    saveManualInstagramLinkSuccess,
    saveManualInstagramLinkFail,
    updateBrand,
    getOffsiteCampaignDetails,
    getBuzzBridgeProfile,
    getHostDashboardSuccess,
    getHostDashboardFail,
    brandSocialLoginSuccess,
    brandSocialLoginFail,
    getWalletDashboard,
    getWalletDashboardSuccess,
    getWalletDashboardFail,
    getCommissionWalletSuccess,
    getCommissionWalletFail,
    cashOutCommissionWalletSuccess,
    cashOutCommissionWalletFail,
    getWalletFundOptionsSuccess,
    getWalletFundOptionsFail,
    fundWalletSuccess,
    fundWalletFail,
    adminCreditCampaignWalletSuccess,
    adminCreditCampaignWalletFail,
    lockEscrowSuccess,
    lockEscrowFail,
    releaseEscrowSuccess,
    releaseEscrowFail,
    payoutEscrowSuccess,
    payoutEscrowFail,
    payoutEscrowRound,
    payoutEscrowRoundSuccess,
    payoutEscrowRoundFail,
    updateAutoReloadSuccess,
    updateAutoReloadFail,
    getWalletTransactionsSuccess,
    getWalletTransactionsFail,
    submitLiveUrlSuccess,
    submitLiveUrlFail,
    retrySubmissionProcessingSuccess,
    retrySubmissionProcessingFail,
    markSharedSuccess,
    markSharedFail,
    requestLiveUrlRevisionSuccess,
    requestLiveUrlRevisionFail,
    setParticipantUploadProgress,
    withdrawFromCampaignSuccess,
    withdrawFromCampaignFail,
    requestDeliveryExtensionSuccess,
    requestDeliveryExtensionFail,
    approveDeliveryExtensionSuccess,
    approveDeliveryExtensionFail,
    rejectDeliveryExtensionSuccess,
    rejectDeliveryExtensionFail,
    openLiveLinkWindowSuccess,
    openLiveLinkWindowFail,
} from './actions';
import type { RootState } from '../root-reducer';
import { mergeBuzzBridgeProfileGroupResponse } from './mergeBuzzBridgeProfileGroupResponse';
import {
    IApproveJoinRequest,
    IBulkApproveJoinRequests,
    IBulkRejectJoinRequests,
    IBulkRescindParticipants,
    IBulkRescindResult,
    IBrandSocialLoginPayload,
    IBrandSocialProfile,
    ICreateBrandSocialLinkPayload,
    IUpdateBrandSocialLinkPayload,
    IBuzzBridgeProfileResponse,
    ICreateCampaignPayload,
    IEscrowPayload,
    ICampaignWalletDepositSocketPayload,
    IAdminCreditWalletRequest,
    IFundWalletPayload,
    IVerifyWalletFundPayload,
    IGetBrands,
    IGetBuzzBridgeProfile,
    IGetPublicInfluencerProfilePayload,
    IInfluencer,
    ISaveManualInstagramLinkPayload,
    IGetCampaigns,
    IGetHostDashboard,
    IGetTransactionsPayload,
    IPayoutPayload,
    IRejectJoinRequest,
    ICancelCampaignInvite,
    IGetCampaignPendingInvites,
    IRescindParticipantApproval,
    IRequestToJoinCampaign,
    IUpdateAutoReloadPayload,
    IUpdateCampaignPayload,
    types,
} from './types';
import { globalErrorHandler } from '../error/saga';
import { uploadFilesSaga, uploadProjectVideoFileBlocking } from '../upload/saga';
import { types as uploadTypes } from '../upload/types';
import { showToastMessage } from '../../utils/AppUtils';
import { parseCampaignCreationEntitlementError } from '../../utils/campaignHostCreationEntitlements';
import { fetchCampaignHostCreationAccess } from '../campaignHostSubscription/actions';
import { manualPlatformLinkToStats } from '../../utils/manualPlatformLinkUtils';
import { parseInfluencerFromPatchResponse, parseInfluencerIdFromCreateResponse } from '../../utils/guestApplyAuthUtils';
import {
    normalizePublicProfileUserName,
    parsePublicInfluencerProfileResponse,
} from '../../services/influencerPublicProfile';
import { buzzBridgeProfileSelector, campaignWorkspaceSelector } from './selectors';
import {
    fetchRemoteAvatarAsFile,
    hasStoredInfluencerProfilePicture,
    PERSIST_SOCIAL_AVATAR_FLAG,
    resolvePreferredSocialAvatarUrl,
} from '../../utils/influencerSocialAvatar';
import {
    extractParticipationBlockedFromError,
    normalizeParticipationGate,
} from '../../utils/campaignParticipationGate';
import { fileToAttachmentKind } from '../../utils/campaignThreadAttachment';
import { MAX_CAMPAIGN_THREAD_LOCATIONS } from '../../utils/campaignThreadLocation';
import { canSendCampaignThreadMessage, isCampaignWorkspaceAuthError } from '../../utils/campaignWorkspaceAccess';
import { CAMPAIGN_ACCESS_DENIED_CODES, CAMPAIGN_ACCESS_DENIED_HTTP_STATUS } from '../../constants/campaignAccessDenied';
import { userProfileSelector } from '../../selectors/selectors';
import { SentryCapture } from '../../analytics/Sentry';
import { Action } from 'redux';
import {
    brandAuthUrl,
    brandReviewByIdUrl,
    brandReviewsUrl,
    brandUrl,
    influencerReviewsUrl,
    influencerReviewByIdUrl,
    buzzbridgeCampaignUrl,
    campaignParticipantBroadcastUrl,
    campaignParticipantsUrl,
    campaignPendingInvitesUrl,
    cancelCampaignInviteUrl,
    campaignParticipantThreadMarkReadUrl,
    campaignThreadsMarkAllReadUrl,
    campaignWalletUrl,
    campaignWalletAdminCreditUrl,
    campaignWalletFundVerifyUrl,
    campaignWalletFundVerifyFlutterwaveUrl,
    commissionWalletUrl,
    commissionWalletCashOutUrl,
    influencersUrl,
    influencersPublicByUserNameUrl,
    projectUrl,
} from '../../configurations/api/url';
import { api } from '../../configurations/api';
import { replaceRouteParam } from '../../utils/routesProcessor';
import { ROUTES } from '../../types/global/routes.types';
import { navigate } from '../navigator/action';
import { dashboardHubPath } from '../../utils/dashboardHub';
import { httpRequest } from '../types';
import { IGenericDocumentModifier } from '../../types/global/helper';
import type { ICampaignApplicationReviewData } from './campaignApplicationReview.types';
import type {
    ICampaignThreadAttachmentInput,
    ICampaignThreadMessage,
    IDeleteCampaignThreadMessagePayload,
    IMarkCampaignThreadReadPayload,
    IMarkAllCampaignThreadsReadPayload,
    IListCampaignThreadMessagesPayload,
    IPatchCampaignThreadMessagePayload,
    ISendCampaignThreadMessagePayload,
    IBroadcastCampaignParticipantMessagePayload,
} from './campaignThreadMessage.types';
import type {
    ICampaignWorkspaceData,
    IGetCampaignWorkspacePayload,
    IMessagesPagination,
    ISubmitParticipantWorkPayload,
    ISubmitLiveUrlPayload,
    IRetrySubmissionProcessingPayload,
    IMarkSharedPayload,
    IRequestLiveUrlRevisionPayload,
    WorkspacePerspective,
} from './campaignWorkspace.types';
import type { ISaveBrandReviewPayload } from './brandReview.types';
import type { ISaveInfluencerReviewPayload } from './influencerReview.types';

// ── Helpers ─────────────────────────────────────────────────────────────

function enrichWorkspaceParticipationGate(data: ICampaignWorkspaceData): ICampaignWorkspaceData {
    const gate =
        normalizeParticipationGate(data.participation_gate) ??
        normalizeParticipationGate(data.campaign?.participation_gate);
    if (!gate) return data;
    return {
        ...data,
        participation_gate: gate,
        campaign: { ...data.campaign, participation_gate: gate },
    };
}

function* handleParticipationBlockedError(
    error: unknown,
    options?: { participantId?: string; perspective?: 'creator' | 'brand' },
): Generator<any, boolean, any> {
    const blocked = extractParticipationBlockedFromError(error);
    if (!blocked) return false;
    yield call(showToastMessage, blocked.message, 'error');
    const pid = options?.participantId?.trim();
    if (pid) {
        yield put(
            getCampaignWorkspace({
                perspective: options?.perspective ?? 'creator',
                participantId: pid,
                messagesPage: 1,
                messagesLimit: 20,
                appendMessages: false,
                silentRefresh: true,
            }),
        );
    }
    return true;
}

function* selectCampaignWorkspaceAccessContext(): Generator<
    any,
    {
        currentUserId: string | undefined;
        currentUserRole: string | undefined;
        currentInfluencerId: string | undefined;
        workspace: ICampaignWorkspaceData | null;
    },
    any
> {
    const userProfile: ReturnType<typeof userProfileSelector> = yield select(userProfileSelector);
    const buzzProfile: IBuzzBridgeProfileResponse | null | undefined = yield select(buzzBridgeProfileSelector);
    const workspace: ICampaignWorkspaceData | null = yield select(campaignWorkspaceSelector);
    return {
        currentUserId: userProfile?._id,
        currentUserRole: userProfile?.role,
        currentInfluencerId: buzzProfile?.data?.influencer?._id,
        workspace,
    };
}

/**
 * Clear thread/workspace cache and leave the route when the caller is not allowed.
 * Used for real 401/403 responses and client-side membership mismatches after account switch.
 */
function* ejectUnauthorizedCampaignWorkspace(options: {
    perspective: WorkspacePerspective;
    campaignId?: string | null;
    toastMessage?: string;
}): Generator<any, void, any> {
    yield put(clearCampaignWorkspace());
    yield call(showToastMessage, options.toastMessage ?? 'You do not have access to this workspace', 'error');
    if (options.perspective === 'brand') {
        const campaignId = options.campaignId?.trim();
        const path = campaignId
            ? replaceRouteParam(ROUTES.BRAND_CAMPAIGN_DETAIL, 'campaignId', campaignId)
            : ROUTES.BRAND_CAMPAIGNS;
        yield put(navigate({ routes: path, skipAuthentication: false }));
        return;
    }
    yield put(navigate({ routes: dashboardHubPath(), skipAuthentication: false }));
}

function* handleUnauthorizedCampaignWorkspaceError(
    error: unknown,
    options: { perspective: WorkspacePerspective; campaignId?: string | null },
): Generator<any, boolean, any> {
    if (!isCampaignWorkspaceAuthError(error)) return false;
    yield* ejectUnauthorizedCampaignWorkspace(options);
    return true;
}

function isolateUploadFields(data: Record<string, any>) {
    const uploadKeys = ['documents', 'rawProfile', 'rawGallery'];
    const uploads: Record<string, any> = {};
    const body: Record<string, any> = {};
    for (const key in data) {
        if (uploadKeys.includes(key)) uploads[key] = data[key];
        else body[key] = data[key];
    }
    return { uploads, body };
}

function* uploadBrandImage(files: File[], documentId: string): Generator<any, string | undefined, any> {
    const urls = yield call(uploadFilesSaga, {
        payload: { collection: 'brands', directory: 'assets', files, id: documentId, path: 'images' },
    });
    return urls?.[0];
}

function* uploadCampaignFile(files: File[], campaignId: string): Generator<any, string | undefined, any> {
    const urls = yield call(uploadFilesSaga, {
        payload: { collection: 'campaigns', directory: 'assets', files, id: campaignId, path: 'files' },
    });
    return urls?.[0];
}

// ── BuzzBridge Profile ──────────────────────────────────────────────────

/**
 * One-time social→Thspian copy when stored profile_picture is empty.
 * Never overwrites an existing picture. CORS may block the fetch — returns undefined.
 */
function* tryPersistSocialAvatarSaga(
    influencerId: string,
    influencer: Pick<IInfluencer, 'profile_picture' | 'instagram' | 'tiktok'> | null | undefined,
): Generator<any, string | undefined, any> {
    if (!influencerId || hasStoredInfluencerProfilePicture(influencer)) return undefined;
    const socialUrl = resolvePreferredSocialAvatarUrl(influencer);
    if (!socialUrl) return undefined;
    try {
        const file: File | null = yield call(fetchRemoteAvatarAsFile, socialUrl);
        if (!file) return undefined;
        const uploaded: string[] = yield call(uploadFilesSaga, {
            payload: {
                id: influencerId,
                files: [file],
                collection: 'influencer',
                directory: 'media',
                path: 'images',
            },
        });
        return uploaded?.[0];
    } catch {
        return undefined;
    }
}

function* updateBuzzProfile({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    const { body, uploads } = isolateUploadFields(payload.payload);
    const persistSocialAvatar = Boolean(body[PERSIST_SOCIAL_AVATAR_FLAG]);
    delete body[PERSIST_SOCIAL_AVATAR_FLAG];
    const request = `${influencersUrl}/${payload.documentId}`;
    try {
        let profilePictureUrl: string[] | undefined;
        let updatedDocuments = [];
        if (uploads) {
            if ('rawProfile' in uploads && Array.isArray(uploads.rawProfile)) {
                profilePictureUrl = yield call(uploadFilesSaga, {
                    payload: {
                        id: payload.documentId,
                        files: uploads.rawProfile,
                        collection: 'influencer',
                        directory: 'media',
                        path: 'images',
                    },
                });
            }
            if ('documents' in uploads && Array.isArray(uploads.documents)) {
                updatedDocuments = yield all(
                    uploads.documents.map(function* (doc): any {
                        if (doc.file) {
                            const uploadedUrl = yield call(uploadFilesSaga, {
                                payload: {
                                    files: [doc.file],
                                    id: payload.documentId,
                                    collection: 'influencer',
                                    directory: 'media',
                                    path: 'documents',
                                },
                            });
                            const { file, ...rest } = doc;
                            return { ...rest, url: uploadedUrl[0] };
                        }
                        const { file, ...rest } = doc;
                        return rest;
                    }),
                );
            }
            if ('rawGallery' in uploads && Array.isArray(uploads.rawGallery) && uploads.rawGallery.length > 0) {
                const galleryUploadUrls: string[] = yield call(uploadFilesSaga, {
                    payload: {
                        files: uploads.rawGallery,
                        id: payload.documentId,
                        collection: 'influencer',
                        directory: 'media',
                        path: 'gallery',
                    },
                });
                body.gallery = [...(body.gallery || []), ...(galleryUploadUrls || [])];
            }
        }

        const hasOwnUpload = Boolean(profilePictureUrl?.[0]);
        if (!hasOwnUpload && persistSocialAvatar) {
            const profile: IBuzzBridgeProfileResponse | null | undefined = yield select(buzzBridgeProfileSelector);
            const current = profile?.data?.influencer;
            const socialUploaded: string | undefined = yield call(
                tryPersistSocialAvatarSaga,
                payload.documentId,
                current,
            );
            if (socialUploaded) {
                profilePictureUrl = [socialUploaded];
            }
        }

        const finalPayload = {
            ...body,
            ...(profilePictureUrl?.[0] && { profile_picture: profilePictureUrl[0] }),
            ...(updatedDocuments.length > 0 && { documents: updatedDocuments }),
        };
        if (Object.keys(finalPayload).length === 0) {
            // Social persist opted in but CORS/download failed — keep remote preview
            if (persistSocialAvatar) {
                yield call(
                    showToastMessage,
                    'Could not copy your social photo. Upload a profile picture to keep it permanently.',
                    'info',
                );
            }
            return;
        }
        const response = yield call(api, request, httpRequest.PATCH, finalPayload, 2, 1000);
        const updatedFields = Object.keys(finalPayload);
        const influencerFromApi = parseInfluencerFromPatchResponse(response);
        // When the API response doesn't include the full influencer doc, fall back to the
        // fields we just patched so the reducer can update them in the store.
        yield put(
            updateBuzzBridgeProfileSuccess({
                ...(influencerFromApi ?? finalPayload),
                updatedFields,
            } as IInfluencer & { updatedFields: string[] }),
        );
        yield call(showToastMessage, 'Profile updated successfully', 'success');
        // Silently refetch so the store reflects the latest server state (e.g. CDN URL after image upload).
        yield put(getBuzzBridgeProfile({ skipRefresh: false }));
    } catch (error: any) {
        yield put(getBuzzBridgeProfileFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* saveManualInstagramLinkSaga({
    payload,
    resolve,
    reject,
}: {
    payload: ISaveManualInstagramLinkPayload;
    resolve?: (influencerId: string) => void;
    reject?: (reason: unknown) => void;
}): Generator<any, any, any> {
    const platform = payload.platform ?? 'instagram';
    const platformStats = manualPlatformLinkToStats(payload.data);
    const platformLabel = platform === 'instagram' ? 'Instagram' : platform === 'tiktok' ? 'TikTok' : 'YouTube';
    try {
        let id = payload.influencerId;

        if (!id) {
            const profile: { data?: { influencer?: { _id?: string } } } | null | undefined = yield select(
                buzzBridgeProfileSelector,
            );
            id = profile?.data?.influencer?._id;
        }

        if (!payload.uploadHeadshotOnly) {
            if (!id) {
                const created = yield call(api, influencersUrl, httpRequest.POST, { [platform]: platformStats });
                id = parseInfluencerIdFromCreateResponse(created);
                if (!id) throw new Error('Could not create influencer profile.');
                const influencerFromCreate = parseInfluencerFromPatchResponse(created);
                yield put(
                    updateBuzzBridgeProfileSuccess({
                        ...(influencerFromCreate ?? { _id: id, [platform]: platformStats }),
                        updatedFields: [platform],
                    } as IInfluencer & { updatedFields: string[] }),
                );
            } else {
                const patchResponse = yield call(api, `${influencersUrl}/${id}`, httpRequest.PATCH, {
                    [platform]: platformStats,
                });
                const influencerFromApi = parseInfluencerFromPatchResponse(patchResponse);
                if (influencerFromApi) {
                    yield put(
                        updateBuzzBridgeProfileSuccess({
                            ...influencerFromApi,
                            updatedFields: [platform],
                        } as IInfluencer & { updatedFields: string[] }),
                    );
                }
            }
        } else if (!id) {
            throw new Error('Influencer id required to upload headshot.');
        }

        if (payload.data.headshotFile && id) {
            const profilePictureUrl: string[] = yield call(uploadFilesSaga, {
                payload: {
                    id,
                    files: [payload.data.headshotFile],
                    collection: 'influencer',
                    directory: 'media',
                    path: 'images',
                },
            });
            if (profilePictureUrl?.[0]) {
                yield call(
                    api,
                    `${influencersUrl}/${id}`,
                    httpRequest.PATCH,
                    {
                        profile_picture: profilePictureUrl[0],
                        [platform]: { ...platformStats, profile_picture: profilePictureUrl[0] },
                    },
                    2,
                    1000,
                );
            }
        } else if (id && !payload.data.headshotFile) {
            const profile: IBuzzBridgeProfileResponse | null | undefined = yield select(buzzBridgeProfileSelector);
            const current = profile?.data?.influencer;
            const forPersist = {
                ...(current ?? {}),
                [platform]: { ...(current?.[platform] as object), ...platformStats },
            } as IInfluencer;
            const socialUploaded: string | undefined = yield call(tryPersistSocialAvatarSaga, id, forPersist);
            if (socialUploaded) {
                yield call(
                    api,
                    `${influencersUrl}/${id}`,
                    httpRequest.PATCH,
                    { profile_picture: socialUploaded },
                    2,
                    1000,
                );
            }
        }

        yield* getBuzzProfile({
            payload: { skipRefresh: false },
            resolve: async () => {},
            reject: async () => {},
        });

        yield put(saveManualInstagramLinkSuccess({ influencerId: id! }));
        yield call(showToastMessage, `${platformLabel} profile saved.`, 'success');
        if (resolve) resolve(id!);
    } catch (error: any) {
        SentryCapture(error);
        yield put(saveManualInstagramLinkFail(error));
        yield call(globalErrorHandler, error);
        if (reject) reject(error);
    }
}

function* getBuzzProfile({
    payload,
    resolve,
    reject,
}: {
    payload: IGetBuzzBridgeProfile;
    resolve: (response: IBuzzBridgeProfileResponse) => Promise<void>;
    reject: (reason: any) => Promise<void>;
}): Generator<any, any, any> {
    const params = new URLSearchParams();
    if (payload.limit) params.append('limit', String(payload.limit));
    if (payload.page) params.append('page', String(payload.page));
    if (payload.group_type) params.append('group_type', String(payload.group_type));
    const request = `${influencersUrl}/me/profile?${params.toString()}`;
    let settled = false;
    try {
        const response: IBuzzBridgeProfileResponse = yield call(api, request, httpRequest.GET, null, 2, 1000);
        let merged: IBuzzBridgeProfileResponse = response;
        if (payload.skipRefresh && payload.group_type) {
            const prev: IBuzzBridgeProfileResponse | null | undefined = yield select(
                (s: RootState) => s.buzzbridge.buzzProfile as IBuzzBridgeProfileResponse | null | undefined,
            );
            merged = mergeBuzzBridgeProfileGroupResponse(prev, response, payload.group_type);
        }
        if (!merged?.data?.influencer) {
            // Success payload without an influencer — treat like "no profile" (common for legacy accounts).
            yield put(getBuzzBridgeProfileNoInfluencer());
            if (resolve) {
                resolve(undefined as unknown as IBuzzBridgeProfileResponse);
                settled = true;
            }
            return;
        }
        yield put(getBuzzBridgeProfileSuccess(merged));
        if (resolve) {
            resolve(response);
            settled = true;
        }
    } catch (error: any) {
        SentryCapture(error);
        const rawStatus = error?.response?.status ?? error?.status;
        const status = typeof rawStatus === 'string' ? parseInt(rawStatus, 10) : rawStatus;
        const bodyMessage =
            typeof error?.data?.message === 'string'
                ? error.data.message
                : typeof error?.data?.error === 'string'
                ? error.data.error
                : typeof error?.message === 'string'
                ? error.message
                : '';
        const isNoInfluencer404 =
            status === 404 ||
            /no influencer profile/i.test(bodyMessage) ||
            /influencer profile.*not found/i.test(bodyMessage) ||
            /influencer not found/i.test(bodyMessage) ||
            /no influencer/i.test(bodyMessage);

        if (isNoInfluencer404) {
            yield put(getBuzzBridgeProfileNoInfluencer());
            /** Resolve so dispatchPromise does not reject — avoids dev overlay / unhandled rejection */
            if (resolve) {
                resolve(undefined as unknown as IBuzzBridgeProfileResponse);
                settled = true;
            }
            return;
        }
        if (reject) reject(error);
        settled = true;
        yield put(getBuzzBridgeProfileFail(error));
        yield call(globalErrorHandler, error);
    } finally {
        if (yield cancelled() && !settled && reject) {
            reject(new Error('Profile fetch cancelled'));
        }
    }
}

function* getPublicInfluencerProfileSaga({
    payload,
    resolve,
    reject,
}: {
    payload: IGetPublicInfluencerProfilePayload;
    resolve?: (influencer: IInfluencer) => void;
    reject?: (reason: unknown) => void;
}): Generator<any, any, any> {
    try {
        const handle = normalizePublicProfileUserName(payload.userName);
        if (!handle) {
            throw new Error('Must provide userName');
        }
        const response = yield call(api, influencersPublicByUserNameUrl(handle), httpRequest.GET, null);
        const influencer = parsePublicInfluencerProfileResponse(response);
        yield put(getPublicInfluencerProfileSuccess(influencer));
        if (resolve) resolve(influencer);
    } catch (error: any) {
        SentryCapture(error);
        yield put(getPublicInfluencerProfileFail(error));
        if (reject) reject(error);
    }
}

// ── Program ─────────────────────────────────────────────────────────────

function* joinProgramSaga({ payload }: any): Generator<any, any, any> {
    try {
        const { rawProfile, ...body } = payload;
        const response = yield call(api, influencersUrl, httpRequest.POST, body);
        let { data } = response.data;

        if (rawProfile?.length && data?._id) {
            const profilePictureUrl: string[] = yield call(uploadFilesSaga, {
                payload: {
                    id: data._id,
                    files: rawProfile,
                    collection: 'influencer',
                    directory: 'media',
                    path: 'images',
                },
            });
            if (profilePictureUrl?.[0]) {
                const patchBody: Record<string, unknown> = { profile_picture: profilePictureUrl[0] };
                if (body.instagram) {
                    patchBody.instagram = { ...body.instagram, profile_picture: profilePictureUrl[0] };
                }
                const patchResponse = yield call(
                    api,
                    `${influencersUrl}/${data._id}`,
                    httpRequest.PATCH,
                    patchBody,
                    2,
                    1000,
                );
                data = patchResponse.data?.data ?? data;
            }
        }

        yield put(joinProgramSuccess(data));
        yield call(showToastMessage, 'Successfully requested to join BuzzBridge program!', 'success');
    } catch (error: any) {
        SentryCapture(error);
        yield put(joinProgramFail(error));
        yield call(globalErrorHandler, error);
    }
}

// ── Campaigns ───────────────────────────────────────────────────────────

function buildClippingPatchFromCreatePayload(payload: ICreateCampaignPayload): Record<string, unknown> | null {
    if (payload.is_clipping == null && !payload.clipping_asset_url) return null;
    const patch: Record<string, unknown> = {
        is_clipping: Boolean(payload.is_clipping),
    };
    if (payload.is_clipping && payload.clipping_asset_url?.trim()) {
        patch.clipping_asset_url = payload.clipping_asset_url.trim();
    } else if (!payload.is_clipping) {
        patch.clipping_asset_url = null;
    }
    return patch;
}

function* createOffsiteCampaignSaga({ payload }: { payload: ICreateCampaignPayload }): Generator<any, any, any> {
    try {
        const { rawFeatureImage, rawAppIconFile, rawAssets, rawSampleVideos: _rawSampleVideos, ...body } = payload;

        if (body.participants_count != null) {
            body.total_participants_count = body.participants_count;
        }

        const response = yield call(api, buzzbridgeCampaignUrl, httpRequest.POST, body);
        let data = response.data?.data ?? response.data;
        const campaignId = data._id;

        const hasFiles = rawFeatureImage || rawAppIconFile || rawAssets?.some(a => a.file);
        const updateBody: Record<string, any> = {
            ...(buildClippingPatchFromCreatePayload(payload) ?? {}),
        };

        if (hasFiles && campaignId) {
            if (rawFeatureImage) {
                const url: string | undefined = yield call(uploadCampaignFile, [rawFeatureImage], campaignId);
                if (url) updateBody.feature_image = url;
            }

            if (rawAppIconFile) {
                const url: string | undefined = yield call(uploadCampaignFile, [rawAppIconFile], campaignId);
                if (url) {
                    const baseInstall = updateBody.app_install || data.app_install || body.app_install || {};
                    updateBody.app_install = { ...baseInstall, app_icon_url: url };
                }
            }

            if (rawAssets?.some(a => a.file)) {
                const uploadedAssets: any[] = [];
                for (const asset of rawAssets) {
                    if (asset.file) {
                        const url: string | undefined = yield call(uploadCampaignFile, [asset.file], campaignId);
                        if (url) {
                            uploadedAssets.push({
                                url,
                                description: asset.description || undefined,
                                requirements: asset.requirements?.length ? asset.requirements : undefined,
                            });
                        }
                    } else {
                        uploadedAssets.push({
                            url: asset.url,
                            description: asset.description || undefined,
                            requirements: asset.requirements?.length ? asset.requirements : undefined,
                        });
                    }
                }
                updateBody.assets = uploadedAssets;
            }
        }

        if (campaignId && Object.keys(updateBody).length > 0) {
            const patchResponse = yield call(
                api,
                `${buzzbridgeCampaignUrl}/${campaignId}`,
                httpRequest.PATCH,
                updateBody,
            );
            const patched = patchResponse?.data?.data ?? patchResponse?.data;
            if (patched && typeof patched === 'object') {
                data = { ...data, ...patched };
            } else {
                data = { ...data, ...updateBody };
            }
        }

        yield put(createOffsiteCampaignSuccess(data));
        yield call(showToastMessage, 'Campaign created successfully!', 'success');
        yield put(fetchCampaignHostCreationAccess());
    } catch (error: any) {
        SentryCapture(error);
        yield put(createOffsiteCampaignFail(error));
        const entitlement = parseCampaignCreationEntitlementError(error);
        if (entitlement.code) {
            yield call(showToastMessage, entitlement.message, 'error');
            yield put(fetchCampaignHostCreationAccess());
        } else {
            yield call(globalErrorHandler, error);
        }
    } finally {
        if (yield cancelled()) {
            yield put(
                createOffsiteCampaignFail({
                    data: { message: 'Cancelled', status: 'cancelled' },
                    statusText: 'Cancelled',
                    status: 0,
                }),
            );
        }
    }
}

function* getOffsiteCampaignDetailsSaga({
    payload,
    resolve,
    reject,
}: {
    payload: { campaignId: string; asBrandHost?: boolean };
    resolve?: (data: unknown) => void;
    reject?: (reason: unknown) => void;
}): Generator<any, any, any> {
    try {
        const path = payload.asBrandHost
            ? `${buzzbridgeCampaignUrl}/${payload.campaignId}`
            : `${buzzbridgeCampaignUrl}/public/${payload.campaignId}`;
        const response = yield call(api, path, httpRequest.GET, null);
        const { data } = response.data;
        yield put(getOffsiteCampaignDetailsSuccess(data));
        if (resolve) resolve(data);
    } catch (error: any) {
        yield put(getOffsiteCampaignDetailsFail(error));
        yield call(globalErrorHandler, error);
        if (reject) reject(error);
    }
}

function* manageOffsiteCampaignsSaga({ payload }: { payload: IGetCampaigns }): Generator<any, any, any> {
    try {
        const params = new URLSearchParams();
        if (payload.status) params.append('status', payload.status);
        if (payload.funded !== undefined) params.append('funded', String(payload.funded));
        if (payload.page) params.append('page', String(payload.page));
        if (payload.limit) params.append('limit', String(payload.limit));
        if (payload.sort) params.append('sort', payload.sort);
        if (payload.search) params.append('search', payload.search);
        if (payload.brand) params.append('brand', payload.brand);
        const qs = params.toString();
        const url = qs ? `${buzzbridgeCampaignUrl}?${qs}` : buzzbridgeCampaignUrl;
        const response = yield call(api, url, httpRequest.GET, null);
        const envelope = response ?? {};
        const inner = envelope.data;
        const campaigns = Array.isArray(inner?.data) ? inner.data : Array.isArray(inner) ? inner : [];
        yield put(
            manageOffsiteCampaignsSuccess({
                campaigns,
                currentPage: envelope.currentPage ?? payload.page ?? 1,
                totalPages: Math.max(1, envelope.totalPages ?? 1),
                totalCount: envelope.totalCount ?? campaigns.length,
            }),
        );
    } catch (error: any) {
        SentryCapture(error);
        yield put(manageOffsiteCampaignsFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* updateOffsiteCampaignSaga({ payload }: { payload: IUpdateCampaignPayload }): Generator<any, any, any> {
    try {
        const body = { ...payload.body };

        if (body.rawFeatureImage) {
            const url: string | undefined = yield call(uploadCampaignFile, [body.rawFeatureImage], payload.campaignId);
            if (url) body.feature_image = url;
            delete body.rawFeatureImage;
        }

        if (body.rawAppIconFile) {
            const url: string | undefined = yield call(uploadCampaignFile, [body.rawAppIconFile], payload.campaignId);
            if (url) {
                const prevInstall =
                    body.app_install && typeof body.app_install === 'object' ? body.app_install : undefined;
                body.app_install = {
                    ...prevInstall,
                    enabled: prevInstall?.enabled ?? true,
                    app_icon_url: url,
                };
            }
            delete body.rawAppIconFile;
        }

        if (body.rawAssets?.some((a: any) => a.file)) {
            const uploadedAssets: any[] = [];
            for (const asset of body.rawAssets) {
                if (asset.file) {
                    const url: string | undefined = yield call(uploadCampaignFile, [asset.file], payload.campaignId);
                    if (url) {
                        uploadedAssets.push({
                            url,
                            description: asset.description || undefined,
                            requirements: asset.requirements?.length ? asset.requirements : undefined,
                        });
                    }
                } else {
                    uploadedAssets.push({
                        url: asset.url,
                        description: asset.description || undefined,
                        requirements: asset.requirements?.length ? asset.requirements : undefined,
                    });
                }
            }
            body.assets = uploadedAssets;
            delete body.rawAssets;
        }

        const response = yield call(api, `${buzzbridgeCampaignUrl}/${payload.campaignId}`, httpRequest.PATCH, body);
        const { data } = response.data;
        yield put(updateOffsiteCampaignSuccess(data));
        yield call(showToastMessage, 'Campaign updated successfully!', 'success');
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
    } catch (error: any) {
        yield put(updateOffsiteCampaignFail(error));
        const entitlement = parseCampaignCreationEntitlementError(error);
        if (entitlement.code) {
            yield call(showToastMessage, entitlement.message, 'error');
            yield put(fetchCampaignHostCreationAccess());
        } else {
            yield call(globalErrorHandler, error);
        }
    }
}

function* deleteOffsiteCampaignSaga({ payload }: { payload: { campaignId: string } }): Generator<any, any, any> {
    try {
        yield call(api, `${buzzbridgeCampaignUrl}/${payload.campaignId}`, httpRequest.DELETE, null);
        yield put(deleteOffsiteCampaignSuccess({ campaignId: payload.campaignId }));
        yield call(showToastMessage, 'Campaign deleted successfully!', 'success');
    } catch (error: any) {
        SentryCapture(error);
        yield put(deleteOffsiteCampaignFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* updateCampaignStatusSaga({
    payload,
}: {
    payload: { campaignId: string; status: 'published' | 'draft' };
}): Generator<any, any, any> {
    try {
        yield call(api, `${buzzbridgeCampaignUrl}/${payload.campaignId}/status`, httpRequest.PATCH, {
            status: payload.status,
        });
        yield put(updateCampaignStatusSuccess());
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
        const label = payload.status === 'published' ? 'Campaign published!' : 'Campaign moved to draft.';
        yield call(showToastMessage, label, 'success');
    } catch (error: any) {
        SentryCapture(error);
        yield put(updateCampaignStatusFail(error));
        yield call(globalErrorHandler, error);
    }
}

// ── Campaign Participants ───────────────────────────────────────────────

function* requestToJoinCampaignSaga({
    payload,
    resolve,
    reject,
}: RequestToJoinCampaignAction): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/campaign/${payload.campaignId}/request`;
        const response = yield call(api, url, httpRequest.POST, {});
        const participant = response.data?.participationRequest ?? response.data?.data;
        yield put(requestToJoinCampaignSuccess(participant));
        yield call(showToastMessage, 'Request to join campaign sent!', 'success');
        if (resolve) resolve(participant);
    } catch (error: any) {
        yield put(requestToJoinCampaignFail(error));
        if (reject) reject(error);
        if (yield* handleParticipationBlockedError(error)) return;
        // 403 = location restriction — surface the backend's specific message
        const httpStatus = error?.status ?? error?.response?.status;
        if (httpStatus === 403) {
            const msg =
                error?.data?.message ??
                error?.response?.data?.message ??
                'This campaign is not available in your region.';
            yield call(showToastMessage, msg, 'error');
            return;
        }
        yield call(globalErrorHandler, error);
    }
}

function* getCampaignJobDetailsSaga({ payload }: { payload: { campaignId: string } }): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/campaign/${payload.campaignId}/requests`;
        const response = yield call(api, url, httpRequest.GET, null);
        const requests = response.data?.requests ?? [];
        yield put(getCampaignJobDetailsSuccess(requests));
    } catch (error: any) {
        SentryCapture(error);
        yield put(getCampaignJobDetailsFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* getCampaignWorkspaceSaga({ payload }: { payload: IGetCampaignWorkspacePayload }): Generator<any, any, any> {
    const {
        perspective,
        participantId,
        messagesPage = 1,
        messagesLimit = 20,
        appendMessages = false,
        silentRefresh = false,
    } = payload;
    const segment = perspective === 'brand' ? 'brand-workspace' : 'creator-workspace';
    const qs = new URLSearchParams({
        messages_page: String(messagesPage),
        messages_limit: String(Math.min(50, Math.max(1, messagesLimit))),
    });
    const url = `${campaignParticipantsUrl}/${participantId}/${segment}?${qs}`;
    try {
        const response = yield call(api, url, httpRequest.GET, null);
        const body = response.data;
        const raw: ICampaignWorkspaceData = body?.data ?? body;
        if (!raw || typeof raw !== 'object' || !raw.campaign?._id) {
            throw Object.assign(new Error('Invalid campaign workspace response'), {
                response: {
                    status: CAMPAIGN_ACCESS_DENIED_HTTP_STATUS,
                    data: {
                        message: 'Not authorized to view this workspace',
                        code: CAMPAIGN_ACCESS_DENIED_CODES.WORKSPACE,
                        details: { code: CAMPAIGN_ACCESS_DENIED_CODES.WORKSPACE },
                    },
                },
            });
        }
        const data = enrichWorkspaceParticipationGate(raw);
        yield put(getCampaignWorkspaceSuccess({ data, append: appendMessages }));
    } catch (error: any) {
        SentryCapture(error);
        // Swallow cancellation errors — takeLatest cancels the previous run when a
        // new GET_CAMPAIGN_WORKSPACE is dispatched (e.g. after approve/revision).
        // Without this guard the catch block of the cancelled saga fires and shows
        // "Something went wrong" even though the request succeeded.
        if (yield cancelled()) return;
        yield put(getCampaignWorkspaceFail(error));
        if (
            yield* handleUnauthorizedCampaignWorkspaceError(error, {
                perspective,
                campaignId: undefined,
            })
        ) {
            return;
        }
        if (!silentRefresh) {
            yield call(globalErrorHandler, error);
        }
    }
}

function getCampaignThreadErrorCode(error: any): string | undefined {
    return error?.response?.data?.details?.code ?? error?.response?.data?.code;
}

function* createCampaignThreadVideoProjects(files: File[]): Generator<any, string[], any> {
    const projectIds: string[] = [];
    for (const file of files) {
        const metadata: { duration: number; width: number; height: number; type: string; codec: string } = yield call(
            getVideoFileMeta,
            file,
        );

        const projectBody = {
            title: file.name.replace(/\.[^/.]+$/, '') || 'Campaign thread video',
            project_type: 'video',
            media_type: 'video',
            public_status: 'private',
            visible: false,
            _is_campaign: true,
            metadata,
        };

        const projectRes: any = yield call(api, projectUrl, httpRequest.POST, projectBody);
        const projectId: string | undefined = projectRes?.data?.data?._id ?? projectRes?.data?._id ?? projectRes?._id;
        if (projectId) projectIds.push(projectId);
    }
    return projectIds;
}

function* startCampaignThreadVideoUploads(files: File[], projectIds: string[]): Generator<any, void, any> {
    for (let i = 0; i < files.length; i++) {
        const projectId = projectIds[i];
        if (!projectId) continue;
        yield call(uploadProjectVideoFileBlocking, {
            projectId,
            file: files[i],
        });
    }
}

function* broadcastCampaignParticipantMessageSaga({
    payload,
}: {
    payload: IBroadcastCampaignParticipantMessagePayload;
}): Generator<any, any, any> {
    try {
        const content = String(payload.content || '').trim();
        if (!content) {
            yield put(broadcastCampaignParticipantMessageFail({ message: 'Message content is required' } as any));
            return;
        }
        const response = yield call(
            api,
            campaignParticipantBroadcastUrl(payload.campaignId),
            httpRequest.POST,
            {
                content,
                ...(payload.statuses?.length ? { statuses: payload.statuses } : {}),
            },
            0,
            2000,
        );
        const data = response?.data?.data ?? response?.data ?? {};
        yield put(
            broadcastCampaignParticipantMessageSuccess({
                jobId: data.jobId,
                queued: Boolean(data.queued ?? true),
                recipient_count: data.recipient_count,
            }),
        );
        const n = data.recipient_count;
        yield call(
            showToastMessage,
            typeof n === 'number'
                ? `Message queued to ${n} creator${n === 1 ? '' : 's'}`
                : 'Message queued to creators',
            'success',
        );
    } catch (error: any) {
        yield put(broadcastCampaignParticipantMessageFail(error));
        yield call(showToastMessage, error?.message || 'Could not queue broadcast message', 'error');
    }
}

function* sendCampaignThreadMessageSaga({
    payload,
}: {
    payload: ISendCampaignThreadMessagePayload;
}): Generator<any, any, any> {
    try {
        const access = yield* selectCampaignWorkspaceAccessContext();
        const workspace = access.workspace;
        const perspective: WorkspacePerspective = workspace?.perspective === 'creator' ? 'creator' : 'brand';
        if (
            !canSendCampaignThreadMessage(workspace, {
                currentUserId: access.currentUserId,
                currentUserRole: access.currentUserRole,
                currentInfluencerId: access.currentInfluencerId,
            })
        ) {
            yield put(
                sendCampaignThreadMessageFail({
                    message: 'Not authorized to send messages',
                    status: CAMPAIGN_ACCESS_DENIED_HTTP_STATUS,
                    response: {
                        status: CAMPAIGN_ACCESS_DENIED_HTTP_STATUS,
                        data: {
                            details: { code: CAMPAIGN_ACCESS_DENIED_CODES.THREAD },
                            code: CAMPAIGN_ACCESS_DENIED_CODES.THREAD,
                        },
                    },
                } as any),
            );
            yield* ejectUnauthorizedCampaignWorkspace({
                perspective,
                campaignId: workspace?.campaign?._id,
                toastMessage: 'You do not have access to send messages in this workspace',
            });
            return;
        }

        const url = `${campaignParticipantsUrl}/${payload.participantId}/messages`;
        const files = payload.files ?? [];
        const videoFiles = files.filter(f => f.type.startsWith('video/'));
        const nonVideoFiles = files.filter(f => !f.type.startsWith('video/'));

        let attachmentInputs: ICampaignThreadAttachmentInput[] = [...(payload.attachments ?? [])];
        let projectIds: string[] = [];

        if (nonVideoFiles.length) {
            const uploaded: string[] = yield call(uploadFilesSaga, {
                payload: {
                    files: nonVideoFiles,
                    collection: 'campaigns',
                    directory: 'messages',
                    id: payload.participantId,
                    path: 'attachments',
                },
            });
            const inputs = nonVideoFiles.flatMap((file, index): ICampaignThreadAttachmentInput[] => {
                const storage_key = uploaded[index];
                if (!storage_key) return [];
                return [
                    {
                        kind: fileToAttachmentKind(file),
                        storage_key,
                        filename: file.name,
                        mime_type: file.type,
                        byte_size: file.size,
                    },
                ];
            });
            attachmentInputs = [...attachmentInputs, ...inputs];
        }

        // Videos: create project → finish resumable upload → then post message (avoids empty project links).
        if (videoFiles.length) {
            projectIds = yield call(createCampaignThreadVideoProjects, videoFiles);
            if (projectIds.length !== videoFiles.length) {
                throw new Error('Failed to create a project for every video');
            }
            yield call(startCampaignThreadVideoUploads, videoFiles, projectIds);
        }

        const locations = payload.locations ?? [];
        if (locations.length > MAX_CAMPAIGN_THREAD_LOCATIONS) {
            yield call(
                showToastMessage,
                `You can share up to ${MAX_CAMPAIGN_THREAD_LOCATIONS} locations per message`,
                'error',
            );
            yield put(sendCampaignThreadMessageFail({ message: 'Too many locations' } as any));
            return;
        }

        const trimmedContent = payload.content?.trim() ?? '';
        const body: Record<string, unknown> = {
            messageType: payload.messageType,
        };
        if (trimmedContent) body.content = trimmedContent;
        if (attachmentInputs.length) body.attachments = attachmentInputs;
        if (projectIds.length) body.project_ids = projectIds;
        if (payload.link_urls?.length) body.link_urls = payload.link_urls;
        if (locations.length) body.locations = locations;

        const hasPayload =
            Boolean(trimmedContent) ||
            attachmentInputs.length > 0 ||
            projectIds.length > 0 ||
            Boolean(payload.link_urls?.length) ||
            locations.length > 0;
        if (!hasPayload) {
            yield call(showToastMessage, 'Add a message, attachment, or location before sending', 'error');
            return;
        }

        const response = yield call(api, url, httpRequest.POST, body);
        const data = response.data?.data ?? response.data;
        const message: ICampaignThreadMessage = data?.message ?? data;
        if (!message || typeof message !== 'object' || !(message as ICampaignThreadMessage)._id) {
            throw Object.assign(new Error('Invalid message response'), {
                response: {
                    status: CAMPAIGN_ACCESS_DENIED_HTTP_STATUS,
                    data: {
                        details: { code: CAMPAIGN_ACCESS_DENIED_CODES.THREAD },
                        code: CAMPAIGN_ACCESS_DENIED_CODES.THREAD,
                        message: 'Not authorized to send messages',
                    },
                },
            });
        }
        yield put(sendCampaignThreadMessageSuccess({ participantId: payload.participantId, message }));
        yield call(showToastMessage, 'Message sent', 'success');
    } catch (error: any) {
        SentryCapture(error);
        yield put(sendCampaignThreadMessageFail(error));
        if (yield* handleParticipationBlockedError(error, { participantId: payload.participantId })) return;
        const access = yield* selectCampaignWorkspaceAccessContext();
        const perspective: WorkspacePerspective = access.workspace?.perspective === 'creator' ? 'creator' : 'brand';
        if (
            yield* handleUnauthorizedCampaignWorkspaceError(error, {
                perspective,
                campaignId: access.workspace?.campaign?._id,
            })
        ) {
            return;
        }
        const code = getCampaignThreadErrorCode(error);
        if (code === 'CAMPAIGN_THREAD_LINK_NOT_ALLOWED') {
            yield call(showToastMessage, 'Only Thspian links can be attached in campaign messages', 'error');
            return;
        }
        if (code === 'CAMPAIGN_THREAD_VIDEO_USE_PROJECT') {
            yield call(showToastMessage, 'Videos are uploaded via Thspian project — please retry', 'error');
            return;
        }
        if (code === 'CAMPAIGN_THREAD_LOCATION_INVALID') {
            yield call(showToastMessage, 'That location pin is invalid — try sharing again', 'error');
            return;
        }
        if (code === 'CAMPAIGN_THREAD_LOCATION_LIMIT') {
            yield call(
                showToastMessage,
                `You can share up to ${MAX_CAMPAIGN_THREAD_LOCATIONS} locations per message`,
                'error',
            );
            return;
        }
        yield call(globalErrorHandler, error);
    }
}

function* listCampaignThreadMessagesSaga({
    payload,
}: {
    payload: IListCampaignThreadMessagesPayload;
}): Generator<any, any, any> {
    const { participantId, messagesPage = 1, messagesLimit = 20, append = false } = payload;
    const limit = Math.min(50, Math.max(1, messagesLimit));
    const qs = new URLSearchParams({
        messages_page: String(messagesPage),
        messages_limit: String(limit),
    });
    const url = `${campaignParticipantsUrl}/${participantId}/messages?${qs}`;
    try {
        const response = yield call(api, url, httpRequest.GET, null);
        const body = response.data?.data ?? response.data;
        const messages: ICampaignThreadMessage[] = body?.messages ?? [];
        const rawPag = body?.messages_pagination;
        const messages_pagination: IMessagesPagination = rawPag ?? {
            page: messagesPage,
            limit,
            total: messages.length,
            total_pages: messages.length ? 1 : 0,
            has_more_older: false,
        };
        yield put(
            listCampaignThreadMessagesSuccess({
                participantId,
                messages,
                messages_pagination,
                append,
            }),
        );
    } catch (error: any) {
        SentryCapture(error);
        yield put(listCampaignThreadMessagesFail(error));
        const access = yield* selectCampaignWorkspaceAccessContext();
        const perspective: WorkspacePerspective = access.workspace?.perspective === 'creator' ? 'creator' : 'brand';
        if (
            yield* handleUnauthorizedCampaignWorkspaceError(error, {
                perspective,
                campaignId: access.workspace?.campaign?._id,
            })
        ) {
            return;
        }
        yield call(globalErrorHandler, error);
    }
}

function* patchCampaignThreadMessageSaga({
    payload,
}: {
    payload: IPatchCampaignThreadMessagePayload;
}): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/${payload.participantId}/messages/${payload.messageId}`;
        const response = yield call(api, url, httpRequest.PATCH, payload.body);
        const data = response.data?.data ?? response.data;
        const message: ICampaignThreadMessage = data?.message ?? data;
        yield put(patchCampaignThreadMessageSuccess({ participantId: payload.participantId, message }));
    } catch (error: any) {
        SentryCapture(error);
        yield put(patchCampaignThreadMessageFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* deleteCampaignThreadMessageSaga({
    payload,
}: {
    payload: IDeleteCampaignThreadMessagePayload;
}): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/${payload.participantId}/messages/${payload.messageId}`;
        const response = yield call(api, url, httpRequest.DELETE, null);
        const data = response.data?.data ?? response.data;
        const messageId = data?.message_id ?? payload.messageId;
        yield put(
            deleteCampaignThreadMessageSuccess({
                participantId: payload.participantId,
                messageId,
            }),
        );
        yield call(showToastMessage, 'Message removed', 'info');
    } catch (error: any) {
        yield put(deleteCampaignThreadMessageFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* markCampaignThreadReadSaga({
    payload,
}: {
    payload: IMarkCampaignThreadReadPayload;
}): Generator<any, any, any> {
    try {
        yield call(api, campaignParticipantThreadMarkReadUrl(payload.participantId), httpRequest.PATCH, null);
        yield put(
            markCampaignThreadReadSuccess({
                participantId: payload.participantId,
                campaignId: payload.campaignId,
            }),
        );
        if (payload.refetchCampaign && payload.campaignId) {
            yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
        }
        if (payload.refetchProfile) {
            yield put(getBuzzBridgeProfile({ skipRefresh: true }));
        }
    } catch (error: any) {
        SentryCapture(error);
        yield put(markCampaignThreadReadFail(error));
    }
}

function* markAllCampaignThreadsReadSaga({
    payload,
}: {
    payload: IMarkAllCampaignThreadsReadPayload;
}): Generator<any, any, any> {
    try {
        yield call(api, campaignThreadsMarkAllReadUrl(payload.campaignId), httpRequest.PATCH, null);
        yield put(markAllCampaignThreadsReadSuccess({ campaignId: payload.campaignId }));
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
        if (payload.refetchProfile) {
            yield put(getBuzzBridgeProfile({ skipRefresh: true }));
        }
    } catch (error: any) {
        SentryCapture(error);
        yield put(markAllCampaignThreadsReadFail(error));
    }
}

// ── Content submission — project-first flow ────────────────────────────────

/** Extracts basic video metadata from a File via a hidden HTMLVideoElement. */
function getVideoFileMeta(
    file: File,
): Promise<{ duration: number; width: number; height: number; type: string; codec: string }> {
    return new Promise((resolve, reject) => {
        const el = document.createElement('video');
        el.preload = 'metadata';
        const src = URL.createObjectURL(file);
        el.src = src;
        el.onloadedmetadata = () => {
            URL.revokeObjectURL(src);
            resolve({
                duration: el.duration,
                width: el.videoWidth,
                height: el.videoHeight,
                type: file.type,
                codec: '',
            });
        };
        el.onerror = () => {
            URL.revokeObjectURL(src);
            reject(new Error('Failed to read video metadata'));
        };
    });
}

/**
 * Creator: create project(s) → finish resumable multipart upload(s) → then
 * content-submission (and system message). Ensures project media links exist
 * before the submission toast / thread update.
 */
function* submitParticipantWorkSaga({ payload }: { payload: ISubmitParticipantWorkPayload }): Generator<any, any, any> {
    const {
        participantId,
        campaignId,
        files,
        deliverableType,
        description,
        externalLink,
        submissionId,
        navigateAfter = true,
        platforms,
        deliverableRoundId,
        slotIndex,
    } = payload;
    const baseUrl = `${campaignParticipantsUrl}/${participantId}/content-submissions`;

    try {
        yield put(setParticipantUploadProgress(0));

        // Step 1: create a project record per video
        const projectIds: string[] = [];
        for (const file of files) {
            const metadata: { duration: number; width: number; height: number; type: string; codec: string } =
                yield call(getVideoFileMeta, file);

            const projectBody = {
                title: file.name.replace(/\.[^/.]+$/, '') || `${deliverableType || 'Campaign'} submission`,
                project_type: 'video',
                media_type: 'video',
                public_status: 'private',
                visible: false,
                _is_campaign: true,
                metadata,
            };

            const projectRes: any = yield call(api, projectUrl, httpRequest.POST, projectBody);
            const projectId: string | undefined =
                projectRes?.data?.data?._id ?? projectRes?.data?._id ?? projectRes?._id;
            if (projectId) projectIds.push(projectId);
        }

        if (projectIds.length !== files.length) {
            throw new Error('Failed to create a project for every uploaded file');
        }

        yield put(setParticipantUploadProgress(5));

        // Step 2: await resumable uploads (project + media linked) before submission
        const fileCount = files.length || 1;
        for (let i = 0; i < files.length; i++) {
            const projectId = projectIds[i];
            if (!projectId) continue;
            const rangeMin = 5 + (i / fileCount) * 85;
            const rangeMax = 5 + ((i + 1) / fileCount) * 85;
            const { cancelled: wasCancelled } = yield race({
                upload: call(uploadProjectVideoFileBlocking, {
                    projectId,
                    file: files[i],
                    onProgress: (filePct: number) =>
                        setParticipantUploadProgress(Math.round(rangeMin + (filePct / 100) * (rangeMax - rangeMin))),
                }),
                cancelled: take(uploadTypes.TERMINATE_UPLOAD),
            });
            if (wasCancelled) {
                yield put(setParticipantUploadProgress(0));
                yield put(
                    submitParticipantWorkFail({
                        data: { message: 'Upload cancelled', status: 'cancelled' },
                        statusText: 'cancelled',
                        status: 0,
                    }),
                );
                return;
            }
        }

        yield put(setParticipantUploadProgress(92));

        // Step 3: submit/update content-submission only after uploads complete
        // Multi-platform mode: always POST — backend handles new vs revision per deliverable internally
        const url = !platforms?.length && submissionId ? `${baseUrl}/${submissionId}` : baseUrl;
        const method = !platforms?.length && submissionId ? httpRequest.PATCH : httpRequest.POST;

        const body: Record<string, any> = { project_ids: projectIds };
        // Multi-platform mode: backend derives deliverable types from platforms — no deliverable_type needed
        if (platforms?.length) {
            body.platforms = platforms;
        } else if (deliverableType) {
            body.deliverable_type = deliverableType;
        }
        if (description?.trim()) body.description = description.trim();
        if (externalLink?.trim()) body.external_link = externalLink.trim();
        if (deliverableRoundId) body.deliverable_round_id = deliverableRoundId;
        if (slotIndex != null) body.slot_index = slotIndex;

        const submissionRes: any = yield call(api, url, method, body);
        const submission = submissionRes?.data?.data ?? submissionRes?.data ?? submissionRes;

        yield put(setParticipantUploadProgress(100));
        yield put(submitParticipantWorkSuccess(submission));
        yield call(showToastMessage, submissionId ? 'Revision submitted' : 'Submission received', 'success');

        // Wait for the toast to be visible before refreshing/navigating
        yield delay(1500);

        yield put(
            getCampaignWorkspace({
                perspective: 'creator',
                participantId,
                messagesPage: 1,
                messagesLimit: 20,
                appendMessages: false,
                silentRefresh: true,
            }),
        );
        if (navigateAfter && campaignId?.trim()) {
            let path = replaceRouteParam(ROUTES.BUZZ_BRIDGE_CAMPAIGN_WORKSPACE, 'campaignId', campaignId.trim());
            path = replaceRouteParam(path, 'participantId', participantId);
            yield put(navigate({ routes: path, skipAuthentication: false }));
        }
    } catch (error: any) {
        SentryCapture(error);
        yield put(setParticipantUploadProgress(0));
        yield put(submitParticipantWorkFail(error));
        if (yield* handleParticipationBlockedError(error, { participantId })) return;
        yield call(globalErrorHandler, error);
    }
}

/** Influencer: create or update a brand review after completed campaign participation */
function* saveBrandReviewSaga({ payload }: { payload: ISaveBrandReviewPayload }): Generator<any, any, any> {
    const { brandId, rating, review_text, campaign_participant, reviewId, participantId } = payload;
    const body: Record<string, unknown> = { rating };
    if (review_text?.trim()) body.review_text = review_text.trim();
    if (campaign_participant) body.campaign_participant = campaign_participant;

    try {
        let review: Record<string, unknown>;
        if (reviewId) {
            const url = brandReviewByIdUrl(reviewId);
            const response = yield call(api, url, httpRequest.PATCH, body);
            const data = response.data?.data ?? response.data;
            review = data?.review ?? data;
            yield call(showToastMessage, 'Review updated', 'success');
        } else {
            const url = brandReviewsUrl(brandId);
            const response = yield call(api, url, httpRequest.POST, body);
            const data = response.data?.data ?? response.data;
            review = data?.review ?? data;
            yield call(showToastMessage, 'Thanks for your review', 'success');
        }
        yield put(saveBrandReviewSuccess({ review: review as any, participantId }));
        if (participantId?.trim()) {
            yield put(
                getCampaignWorkspace({
                    perspective: 'creator',
                    participantId: participantId.trim(),
                    messagesPage: 1,
                    messagesLimit: 20,
                    appendMessages: false,
                    silentRefresh: true,
                }),
            );
        }
    } catch (error: any) {
        SentryCapture(error);
        yield put(saveBrandReviewFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* fetchBrandReviewsPageSaga({
    payload,
    resolve,
    reject,
}: {
    payload: { brandId: string; page?: number; limit?: number };
    resolve?: (v: any) => void;
    reject?: (e: any) => void;
}): Generator<any, void, any> {
    const page = payload.page ?? 1;
    const limit = payload.limit ?? 10;
    try {
        const url = `${brandReviewsUrl(payload.brandId)}?page=${page}&limit=${limit}`;
        const response = yield call(api, url, 'GET', null);
        const { unwrapBrandReviewsList } = require('../../utils/brandReviewsApi');
        const data = unwrapBrandReviewsList(response);
        yield put(fetchBrandReviewsPageSuccess(data));
        if (typeof resolve === 'function') resolve(data);
    } catch (error: any) {
        SentryCapture(error);
        yield put(fetchBrandReviewsPageFail(error));
        if (typeof reject === 'function') reject(error);
    }
}

/** Brand: create or update an influencer review after completed campaign participation */
function* saveInfluencerReviewSaga({ payload }: { payload: ISaveInfluencerReviewPayload }): Generator<any, any, any> {
    const { influencerId, rating, review_text, campaign_participant, reviewId, participantId } = payload;
    const body: Record<string, unknown> = { rating };
    if (review_text?.trim()) body.review_text = review_text.trim();
    if (campaign_participant) body.campaign_participant = campaign_participant;

    try {
        let review: Record<string, unknown>;
        if (reviewId) {
            const url = influencerReviewByIdUrl(reviewId);
            const response = yield call(api, url, httpRequest.PATCH, body);
            const data = response.data?.data ?? response.data;
            review = data?.review ?? data;
            yield call(showToastMessage, 'Review updated', 'success');
        } else {
            const url = influencerReviewsUrl(influencerId);
            const response = yield call(api, url, httpRequest.POST, body);
            const data = response.data?.data ?? response.data;
            review = data?.review ?? data;
            yield call(showToastMessage, 'Thanks for your review', 'success');
        }
        yield put(saveInfluencerReviewSuccess({ review: review as any, participantId }));
        if (participantId?.trim()) {
            yield put(
                getCampaignWorkspace({
                    perspective: 'brand',
                    participantId: participantId.trim(),
                    messagesPage: 1,
                    messagesLimit: 20,
                    appendMessages: false,
                    silentRefresh: true,
                }),
            );
        }
    } catch (error: any) {
        yield put(saveInfluencerReviewFail(error));
        yield call(globalErrorHandler, error);
    }
}

/** Creator: submit live social post URL after content is approved */
function* submitLiveUrlSaga({ payload }: { payload: ISubmitLiveUrlPayload }): Generator<any, any, any> {
    const { participantId, submissionId, liveUrls } = payload;
    const url = `${campaignParticipantsUrl}/${participantId}/content-submissions/${submissionId}`;
    try {
        const response = yield call(api, url, httpRequest.PATCH, { action: 'submit_live_url', live_urls: liveUrls });
        yield put(submitLiveUrlSuccess(response.data?.data ?? response.data));
        yield call(showToastMessage, 'Live URL submitted', 'success');
        yield put(
            getCampaignWorkspace({
                perspective: 'creator',
                participantId,
                messagesPage: 1,
                messagesLimit: 20,
                appendMessages: false,
                silentRefresh: true,
            }),
        );
    } catch (error: any) {
        yield put(submitLiveUrlFail(error));
        if (yield* handleParticipationBlockedError(error, { participantId })) return;
        yield call(globalErrorHandler, error);
    }
}

/** Creator: trigger backend to re-process stuck/failed projects using the existing S3 key */
function* retrySubmissionProcessingSaga({
    payload,
}: {
    payload: IRetrySubmissionProcessingPayload;
}): Generator<any, any, any> {
    const { participantId, submissionId, campaignId } = payload;
    const url = `${campaignParticipantsUrl}/${participantId}/content-submissions/${submissionId}/retry-processing`;
    try {
        const response: any = yield call(api, url, httpRequest.POST, {});
        yield put(retrySubmissionProcessingSuccess(response.data?.data ?? response.data));
        yield call(showToastMessage, 'Retry triggered — processing will resume shortly', 'success');
        yield put(
            getCampaignWorkspace({
                perspective: 'creator',
                participantId,
                messagesPage: 1,
                messagesLimit: 20,
                appendMessages: false,
            }),
        );
        if (campaignId?.trim()) {
            let path = replaceRouteParam(ROUTES.BUZZ_BRIDGE_CAMPAIGN_WORKSPACE, 'campaignId', campaignId.trim());
            path = replaceRouteParam(path, 'participantId', participantId);
            yield put(navigate({ routes: path, skipAuthentication: false }));
        }
    } catch (error: any) {
        yield put(retrySubmissionProcessingFail(error));
        if (yield* handleParticipationBlockedError(error, { participantId })) return;
        yield call(globalErrorHandler, error);
    }
}

/** Brand: mark submission as shared (post is live and confirmed) */
function* markSharedSaga({ payload }: { payload: IMarkSharedPayload }): Generator<any, any, any> {
    const { participantId, submissionId } = payload;
    const url = `${campaignParticipantsUrl}/${participantId}/content-submissions/${submissionId}`;
    try {
        const response = yield call(api, url, httpRequest.PATCH, { action: 'mark_shared' });
        yield put(markSharedSuccess(response.data?.data ?? response.data));
        yield call(showToastMessage, 'Marked as shared', 'success');
        yield put(
            getCampaignWorkspace({
                perspective: 'brand',
                participantId,
                messagesPage: 1,
                messagesLimit: 20,
                appendMessages: false,
                silentRefresh: true,
            }),
        );
    } catch (error: any) {
        yield put(markSharedFail(error));
        yield call(globalErrorHandler, error);
    }
}

/** Brand: request creator to revise/resubmit live URL */
function* requestLiveUrlRevisionSaga({
    payload,
}: {
    payload: IRequestLiveUrlRevisionPayload;
}): Generator<any, any, any> {
    const { participantId, submissionId, feedback } = payload;
    const url = `${campaignParticipantsUrl}/${participantId}/content-submissions/${submissionId}`;
    try {
        const response = yield call(api, url, httpRequest.PATCH, { action: 'request_live_url_revision', feedback });
        yield put(requestLiveUrlRevisionSuccess(response.data?.data ?? response.data));
        yield call(showToastMessage, 'Revision requested', 'success');
        yield put(
            getCampaignWorkspace({
                perspective: 'brand',
                participantId,
                messagesPage: 1,
                messagesLimit: 20,
                appendMessages: false,
                silentRefresh: true,
            }),
        );
    } catch (error: any) {
        yield put(requestLiveUrlRevisionFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* withdrawFromCampaignSaga({ payload }: { payload: { participantId: string } }): Generator<any, any, any> {
    const url = `${campaignParticipantsUrl}/${payload.participantId}/withdraw`;
    try {
        const response: any = yield call(api, url, httpRequest.POST, {});
        yield put(withdrawFromCampaignSuccess(response.data?.data ?? response.data));
        yield call(showToastMessage, 'You have opted out of this campaign', 'success');
        yield put(navigate({ routes: dashboardHubPath(), skipAuthentication: false }));
    } catch (error: any) {
        yield put(withdrawFromCampaignFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* requestDeliveryExtensionSaga({
    payload,
}: {
    payload: { participantId: string; requestedDays: number; reason?: string; round_id?: string };
}): Generator<any, any, any> {
    const url = `${campaignParticipantsUrl}/${payload.participantId}/request-delivery-extension`;
    try {
        const response: any = yield call(api, url, httpRequest.POST, {
            requested_days: payload.requestedDays,
            reason: payload.reason ?? '',
            ...(payload.round_id && { round_id: payload.round_id }),
        });
        yield put(requestDeliveryExtensionSuccess(response.data?.data ?? response.data));
        yield call(showToastMessage, 'Extension request submitted', 'success');
    } catch (error: any) {
        yield put(requestDeliveryExtensionFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* approveDeliveryExtensionSaga({
    payload,
}: {
    payload: { participantId: string; requestId: string };
}): Generator<any, any, any> {
    const url = `${campaignParticipantsUrl}/${payload.participantId}/delivery-extension/${payload.requestId}/approve`;
    try {
        const response: any = yield call(api, url, httpRequest.PATCH, {});
        yield put(approveDeliveryExtensionSuccess(response.data?.data ?? response.data));
        yield call(showToastMessage, 'Extension approved', 'success');
        yield put(
            getCampaignWorkspace({
                perspective: 'brand',
                participantId: payload.participantId,
                silentRefresh: true,
            }),
        );
    } catch (error: any) {
        yield put(approveDeliveryExtensionFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* rejectDeliveryExtensionSaga({
    payload,
}: {
    payload: { participantId: string; requestId: string };
}): Generator<any, any, any> {
    const url = `${campaignParticipantsUrl}/${payload.participantId}/delivery-extension/${payload.requestId}/reject`;
    try {
        const response: any = yield call(api, url, httpRequest.PATCH, {});
        yield put(rejectDeliveryExtensionSuccess(response.data?.data ?? response.data));
        yield call(showToastMessage, 'Extension request declined', 'info');
        yield put(
            getCampaignWorkspace({
                perspective: 'brand',
                participantId: payload.participantId,
                silentRefresh: true,
            }),
        );
    } catch (error: any) {
        yield put(rejectDeliveryExtensionFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* openLiveLinkWindowSaga({
    payload,
}: {
    payload: { participantId: string; roundId?: string | null };
}): Generator<any, any, any> {
    const url = `${campaignParticipantsUrl}/${payload.participantId}/live-link-window`;
    try {
        const response: any = yield call(api, url, httpRequest.POST, {
            ...(payload.roundId ? { round_id: payload.roundId } : {}),
        });
        yield put(openLiveLinkWindowSuccess(response.data?.data ?? response.data));
        yield call(showToastMessage, 'Live link window opened for 24 hours', 'success');
        yield put(
            getCampaignWorkspace({
                perspective: 'brand',
                participantId: payload.participantId,
                silentRefresh: true,
            }),
        );
    } catch (error: any) {
        yield put(openLiveLinkWindowFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* getCampaignApplicationReviewSaga({
    payload,
}: {
    payload: { participantId: string };
}): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/${payload.participantId}/application-review`;
        const response = yield call(api, url, httpRequest.GET, null);
        const body = response.data;
        const data: ICampaignApplicationReviewData = body?.data ?? body;
        yield put(getCampaignApplicationReviewSuccess(data));
    } catch (error: any) {
        yield put(getCampaignApplicationReviewFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* approveCampaignJoinRequestSaga({ payload }: { payload: IApproveJoinRequest }): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/${payload.requestId}/approve`;
        const response = yield call(api, url, httpRequest.PATCH, { campaignId: payload.campaignId });
        const participant = response.data?.participationRequest ?? response.data?.data;
        const nestedCommission = response.data?.commission ?? participant?.commission;
        const code = nestedCommission?.code || participant?.commission_code;
        const shareUrl = nestedCommission?.share_url;
        const merged = {
            ...participant,
            ...(code ? { commission_code: code } : {}),
            ...(nestedCommission || code || shareUrl
                ? { commission: { ...nestedCommission, code, share_url: shareUrl } }
                : {}),
        };
        yield put(approveCampaignJoinRequestSuccess(merged));
        if (code || shareUrl) {
            yield call(
                showToastMessage,
                shareUrl ? `Approved. Share link: ${shareUrl}` : `Approved. Commission code: ${code}`,
                'success',
            );
        } else {
            yield call(showToastMessage, 'Request approved successfully!', 'success');
        }
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
    } catch (error: any) {
        yield put(approveCampaignJoinRequestFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* bulkApproveCampaignJoinRequestsSaga({
    payload,
}: {
    payload: IBulkApproveJoinRequests;
}): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/bulk-approve`;
        const body: IBulkApproveJoinRequests = { campaignId: payload.campaignId };
        if (payload.participantIds?.length) body.participantIds = payload.participantIds;
        const response = yield call(api, url, httpRequest.PATCH, body);
        const approved: number = response.data?.data?.approved ?? 0;
        yield put(bulkApproveCampaignJoinRequestsSuccess({ approved, campaignId: payload.campaignId }));
        yield call(showToastMessage, `bulk application approval, successful!`, 'success');
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
    } catch (error: any) {
        yield put(bulkApproveCampaignJoinRequestsFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* bulkRejectCampaignJoinRequestsSaga({
    payload,
}: {
    payload: IBulkRejectJoinRequests;
}): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/bulk-reject`;
        const body: IBulkRejectJoinRequests = { campaignId: payload.campaignId };
        if (payload.participantIds?.length) body.participantIds = payload.participantIds;
        if (payload.reason) body.reason = payload.reason;
        const response = yield call(api, url, httpRequest.PATCH, body);
        const raw = response.data?.data ?? response.data ?? {};
        const rejected: number = raw.rejected ?? payload.participantIds?.length ?? 0;
        yield put(bulkRejectCampaignJoinRequestsSuccess({ rejected, campaignId: payload.campaignId }));
        yield call(showToastMessage, `${rejected} application(s) rejected`, 'success');
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
    } catch (error: any) {
        yield put(bulkRejectCampaignJoinRequestsFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* bulkRescindCampaignParticipantsSaga({
    payload,
}: {
    payload: IBulkRescindParticipants;
}): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/bulk-rescind-approval`;
        const body: IBulkRescindParticipants = { campaignId: payload.campaignId };
        if (payload.participantIds?.length) body.participantIds = payload.participantIds;
        if (payload.reason) body.reason = payload.reason;
        const response = yield call(api, url, httpRequest.PATCH, body);
        // Handle both { data: { rescinded } } and flat { rescinded } response shapes
        const raw = response.data?.data ?? response.data ?? {};
        const data: IBulkRescindResult = {
            rescinded: raw.rescinded ?? payload.participantIds?.length ?? 0,
            skipped: raw.skipped ?? 0,
            skipped_details: raw.skipped_details ?? [],
            participants_count: raw.participants_count,
        };
        yield put(bulkRescindCampaignParticipantsSuccess({ ...data, campaignId: payload.campaignId }));
        yield call(showToastMessage, `${data.rescinded} creator(s) removed from roster`, 'success');
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
    } catch (error: any) {
        yield put(bulkRescindCampaignParticipantsFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* rejectCampaignJoinRequestSaga({ payload }: { payload: IRejectJoinRequest }): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/${payload.requestId}/reject`;
        const response = yield call(api, url, httpRequest.PATCH, {
            campaignId: payload.campaignId,
            ...(payload.reason && { reason: payload.reason }),
        });
        const participant = response.data?.participationRequest ?? response.data?.data;
        yield put(rejectCampaignJoinRequestSuccess(participant));
        yield call(showToastMessage, 'Request rejected', 'info');
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
    } catch (error: any) {
        yield put(rejectCampaignJoinRequestFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* getCampaignPendingInvitesSaga({
    payload,
}: {
    payload: IGetCampaignPendingInvites;
}): Generator<any, any, any> {
    try {
        const params = new URLSearchParams();
        if (payload.page) params.set('page', String(payload.page));
        if (payload.limit) params.set('limit', String(payload.limit));
        if (payload.search) params.set('search', payload.search);
        const qs = params.toString();
        const url = `${campaignPendingInvitesUrl(payload.campaignId)}${qs ? `?${qs}` : ''}`;
        const response = yield call(api, url, httpRequest.GET, null);
        const data = response.data?.data ?? response.data;
        const invites = data?.invites ?? [];
        const pagination = data?.pagination ?? {
            page: payload.page ?? 1,
            limit: payload.limit ?? 20,
            total: invites.length,
            totalPages: 1,
            hasMore: false,
        };
        yield put(
            getCampaignPendingInvitesSuccess({
                campaignId: payload.campaignId,
                invites,
                pagination,
            }),
        );
    } catch (error: any) {
        yield put(getCampaignPendingInvitesFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* cancelCampaignInviteSaga({ payload }: { payload: ICancelCampaignInvite }): Generator<any, any, any> {
    try {
        yield call(api, cancelCampaignInviteUrl(payload.participantId), httpRequest.PATCH, null);
        yield put(
            cancelCampaignInviteSuccess({
                participantId: payload.participantId,
                campaignId: payload.campaignId,
            }),
        );
        yield call(showToastMessage, 'Invite cancelled', 'info');
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
    } catch (error: any) {
        yield put(cancelCampaignInviteFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* rescindCampaignParticipantApprovalSaga({
    payload,
}: {
    payload: IRescindParticipantApproval;
}): Generator<any, any, any> {
    try {
        const url = `${campaignParticipantsUrl}/${payload.participantId}/rescind-approval`;
        const response = yield call(api, url, httpRequest.PATCH, {
            ...(payload.reason ? { reason: payload.reason } : {}),
        });
        const data = response.data?.data ?? response.data;
        const participant = data?.participationRequest ?? data;
        const participants_count = data?.participants_count;
        yield put(
            rescindCampaignParticipantApprovalSuccess({
                participant,
                participantId: payload.participantId,
                campaignId: payload.campaignId,
                participants_count,
            }),
        );
        yield call(showToastMessage, 'Creator removed from campaign', 'info');
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaignId, asBrandHost: true }));
    } catch (error: any) {
        yield put(rescindCampaignParticipantApprovalFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* inviteInfluencerSaga({ payload }: any): Generator<any, any, any> {
    try {
        const response = yield call(api, campaignParticipantsUrl, httpRequest.POST, payload);
        const participant = response.data?.data;
        yield put(sendCampaignMessageSuccess(participant));
        yield call(showToastMessage, 'Influencer invited successfully!', 'success');
    } catch (error: any) {
        yield put(sendCampaignMessageFail(error));
        yield call(globalErrorHandler, error);
    }
}

// ── Deliverables / Messages / Posts (placeholders — wire when backend ready) ─

function* requestDeliverableUpdateSaga({ payload }: any): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${campaignParticipantsUrl}/${payload.participantId}/content-submissions/${payload.submissionId}`,
            httpRequest.PATCH,
            {
                action: 'request_revision',
                feedback: payload.feedback,
                reasons: payload.reasons,
                comment: payload.comment,
            },
        );
        yield put(requestDeliverableUpdateSuccess(response.data?.data));
        yield call(showToastMessage, response.data?.message ?? 'Revision request sent!', 'success');
    } catch (error: any) {
        yield put(requestDeliverableUpdateFail(error));
        yield call(globalErrorHandler, error);
        return;
    }
    try {
        yield put(
            getCampaignWorkspace({
                perspective: 'brand',
                participantId: payload.participantId,
                messagesPage: 1,
                messagesLimit: 20,
                appendMessages: false,
            }),
        );
    } catch (_) {
        // Workspace refresh failure is non-fatal — the revision request already succeeded
    }
}

function* bulkRequestRevisionSaga({ payload }: any): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${campaignParticipantsUrl}/${payload.participantId}/bulk-request-revision`,
            httpRequest.PATCH,
            { feedback: payload.feedback, reasons: payload.reasons, comment: payload.comment },
        );
        yield put(bulkRequestRevisionSuccess(response.data?.data));
        yield call(showToastMessage, response.data?.message ?? 'Revision requested for all submissions!', 'success');
    } catch (error: any) {
        yield put(bulkRequestRevisionFail(error));
        yield call(globalErrorHandler, error);
        return;
    }
    try {
        yield put(
            getCampaignWorkspace({
                perspective: 'brand',
                participantId: payload.participantId,
                messagesPage: 1,
                messagesLimit: 20,
                appendMessages: false,
            }),
        );
    } catch (_) {
        // non-fatal
    }
}

function* relaunchCampaignSaga({ payload }: any): Generator<any, any, any> {
    try {
        const response = yield call(api, `${buzzbridgeCampaignUrl}/${payload.campaignId}/rerun`, httpRequest.POST, {
            ...(payload.title ? { title: payload.title } : {}),
            start_date: payload.start_date,
            end_date: payload.end_date,
        });
        const newCampaign = response.data?.data;
        yield put(relaunchCampaignSuccess(newCampaign));
        yield call(showToastMessage, response.data?.message ?? 'Campaign relaunched successfully!', 'success');
        return newCampaign;
    } catch (error: any) {
        yield put(relaunchCampaignFail(error));
        yield call(globalErrorHandler, error);
    }
}

// function* sendCampaignMessageSaga({ payload }: any): Generator<any, any, any> {
//     try {
//         const response = yield call(api, `${buzzbridgeCampaignUrl}/messages`, httpRequest.POST, payload);
//         yield put(sendCampaignMessageSuccess(response.data?.data));
//     } catch (error: any) {
//         yield put(sendCampaignMessageFail(error));
//         yield call(globalErrorHandler, error);
//     }
// }

function* deleteCampaignMessageSaga({ payload }: any): Generator<any, any, any> {
    try {
        yield call(api, `${buzzbridgeCampaignUrl}/messages/${payload.messageId}`, httpRequest.DELETE, null);
        yield put(deleteCampaignMessageSuccess(payload));
        yield call(showToastMessage, 'Message deleted!', 'success');
    } catch (error: any) {
        yield put(deleteCampaignMessageFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* updateCampaignMessageSaga({ payload }: any): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${buzzbridgeCampaignUrl}/messages/${payload.messageId}`,
            httpRequest.PATCH,
            payload,
        );
        yield put(updateCampaignMessageSuccess(response.data?.data));
        yield call(showToastMessage, 'Message updated!', 'success');
    } catch (error: any) {
        SentryCapture(error);
        yield put(updateCampaignMessageFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* approveDeliverableSubmissionSaga({ payload }: any): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${campaignParticipantsUrl}/${payload.participantId}/content-submissions/${payload.deliverableId}`,
            httpRequest.PATCH,
            { action: 'approve' },
        );
        yield put(approveDeliverableSubmissionSuccess(response.data?.submission ?? response.data));
        yield call(showToastMessage, 'Deliverable approved!', 'success');
    } catch (error: any) {
        SentryCapture(error);
        yield put(approveDeliverableSubmissionFail(error));
        yield call(globalErrorHandler, error);
        return;
    }
    yield put(
        getCampaignWorkspace({
            perspective: 'brand',
            participantId: payload.participantId,
            messagesPage: 1,
            messagesLimit: 20,
            appendMessages: false,
            silentRefresh: true,
        }),
    );
}

function* schedulePostSaga({ payload }: any): Generator<any, any, any> {
    try {
        const response = yield call(api, `${buzzbridgeCampaignUrl}/posts/schedule`, httpRequest.POST, payload);
        yield put(schedulePostSuccess(response.data?.data));
        yield call(showToastMessage, 'Post scheduled successfully!', 'success');
    } catch (error: any) {
        yield put(schedulePostFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* uploadDeliverableSaga({ payload }: any): Generator<any, any, any> {
    try {
        const response = yield call(api, `${buzzbridgeCampaignUrl}/deliverables/upload`, httpRequest.POST, payload);
        yield put(uploadDeliverableSuccess(response.data?.data));
        yield call(showToastMessage, 'Deliverable uploaded successfully!', 'success');
    } catch (error: any) {
        yield put(uploadDeliverableFail(error));
        yield call(globalErrorHandler, error);
    }
}

// ── Brands ──────────────────────────────────────────────────────────────

function* getBrandsSaga({ payload }: { payload: IGetBrands }): Generator<any, any, any> {
    if (payload.searchTerm && payload.searchTerm.length > 0) {
        try {
            const response = yield call(api, `${brandUrl}/search`, httpRequest.POST, payload);
            const { data } = response;
            yield put(getBrandsSuccess(data));
        } catch (error: any) {
            yield put(getBrandsFail(error));
            yield call(globalErrorHandler, error);
        }
    } else {
        try {
            const response = yield call(api, brandUrl, httpRequest.GET, payload);
            const { data } = response.data;
            yield put(getBrandsSuccess(data));
        } catch (error: any) {
            yield put(getBrandsFail(error));
            yield call(globalErrorHandler, error);
        }
    }
}

function* getBrandSaga({ payload }: { payload: string }): Generator<any, any, any> {
    try {
        const response = yield call(api, `${brandUrl}/${payload}`, httpRequest.GET, {}, 0, 0, false);
        const { data } = response.data;
        yield put(getBrandSuccess(data));
    } catch (error: any) {
        SentryCapture(error);
        yield put(getBrandFail(error));
    }
}

function* addBrandSaga({ payload, resolve, reject }: AddBrandAction): Generator<any, any, any> {
    try {
        const { rawLogo, rawFeatureImage, ...body } = payload;
        const response = yield call(api, brandUrl, httpRequest.POST, body);
        const { data } = response.data;
        yield put(addBrandSuccess(data));
        if (resolve) resolve(data);
        const hasFiles = rawLogo || rawFeatureImage;
        if (hasFiles) {
            yield put(
                updateBrand({
                    documentId: data._id,
                    payload: {
                        ...(rawLogo && { logo: rawLogo }),
                        ...(rawFeatureImage && { feature_image: rawFeatureImage }),
                    },
                    fromCreate: true,
                }),
            );
        }
    } catch (error: any) {
        SentryCapture(error);
        yield put(addBrandFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* updateBrandSaga({ payload, resolve, reject }: UpdateBrandAction): Generator<any, any, any> {
    const body = { ...payload.payload };
    try {
        if (body.logo && Array.isArray(body.logo)) {
            const url: string | undefined = yield call(uploadBrandImage, body.logo, payload.documentId);
            if (url) body.logo = url;
            else delete body.logo;
        }
        if (body.feature_image && Array.isArray(body.feature_image)) {
            const url: string | undefined = yield call(uploadBrandImage, body.feature_image, payload.documentId);
            if (url) body.feature_image = url;
            else delete body.feature_image;
        }
        const response = yield call(api, `${brandUrl}/${payload.documentId}`, httpRequest.PATCH, body);
        const { data } = response.data;
        yield put(updateBrandSuccess(data));
        yield call(
            showToastMessage,
            payload.fromCreate ? 'Brand added successfully!' : 'Brand updated successfully!',
            'success',
        );
        if (resolve) resolve(data);
    } catch (error: any) {
        yield put(updateBrandFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* deleteBrandSaga({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        yield call(api, `${brandUrl}/${payload.documentId}`, httpRequest.DELETE, {});
        yield put(deleteBrandSuccess(payload));
        yield call(showToastMessage, 'Brand deleted successfully!', 'success');
    } catch (error: any) {
        SentryCapture(error);
        yield put(deleteBrandFail(error));
        yield call(globalErrorHandler, error);
    }
}

// ── Host Dashboard ──────────────────────────────────────────────────────

function* getHostDashboardSaga({ payload }: { payload: IGetHostDashboard }): Generator<any, any, any> {
    try {
        const url = payload.brandId
            ? `${buzzbridgeCampaignUrl}/host-dashboard?brandId=${payload.brandId}`
            : `${buzzbridgeCampaignUrl}/host-dashboard`;
        const response = yield call(api, url, httpRequest.GET, null);
        const { data } = response;
        yield put(getHostDashboardSuccess(data));
    } catch (error: any) {
        yield put(getHostDashboardFail(error));
        yield call(globalErrorHandler, error);
    }
}

// ── Brand Social Login ──────────────────────────────────────────────────

function* brandSocialLoginSaga({ payload, resolve, reject }: BrandSocialLoginAction): Generator<any, any, any> {
    try {
        const response = yield call(api, `${brandAuthUrl}/exchange`, httpRequest.POST, payload);
        yield put(brandSocialLoginSuccess(response.data));
        yield call(showToastMessage, 'Account linked successfully!', 'success');
        if (resolve) resolve(response);
    } catch (error: any) {
        SentryCapture(error);
        yield put(brandSocialLoginFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* createBrandSocialLinkSaga({
    payload,
    resolve,
    reject,
}: CreateBrandSocialLinkAction): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${brandUrl}/${payload.brandId}/social-links`,
            httpRequest.POST,
            payload.payload,
        );
        const link = (response.data?.data ?? response.data) as IBrandSocialProfile;
        yield call(showToastMessage, 'Social profile saved.', 'success');
        if (resolve) resolve(link);
    } catch (error: any) {
        SentryCapture(error);
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* updateBrandSocialLinkSaga({
    payload,
    resolve,
    reject,
}: UpdateBrandSocialLinkAction): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${brandUrl}/${payload.brandId}/social-links/${payload.linkId}`,
            httpRequest.PATCH,
            payload.payload,
        );
        const link = (response.data?.data ?? response.data) as IBrandSocialProfile;
        yield call(showToastMessage, 'Social profile updated.', 'success');
        if (resolve) resolve(link);
    } catch (error: any) {
        SentryCapture(error);
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

// ── Campaign Wallet ─────────────────────────────────────────────────────

function* getWalletDashboardSaga(): Generator<any, any, any> {
    try {
        const response = yield call(api, `${campaignWalletUrl}/dashboard`, httpRequest.GET, null);
        yield put(getWalletDashboardSuccess(response.data));
    } catch (error: any) {
        yield put(getWalletDashboardFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* getCommissionWalletSaga(): Generator<any, any, any> {
    try {
        const response = yield call(api, commissionWalletUrl, httpRequest.GET, null);
        const data = response?.data?.data ?? response?.data ?? response;
        yield put(getCommissionWalletSuccess(data));
    } catch (error: any) {
        yield put(getCommissionWalletFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* cashOutCommissionWalletSaga(): Generator<any, any, any> {
    try {
        const response = yield call(api, commissionWalletCashOutUrl, httpRequest.POST, null);
        const data = response?.data?.data ?? response?.data ?? response;
        yield put(cashOutCommissionWalletSuccess(data));
        const transferred = Number(data?.transferred_cents ?? 0);
        if (transferred > 0) {
            yield call(
                showToastMessage,
                `${(transferred / 100).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                })} moved to your campaign balance for cash out`,
                'success',
            );
        } else {
            yield call(showToastMessage, 'No cleared commission available to cash out yet', 'info');
        }
    } catch (error: any) {
        yield put(cashOutCommissionWalletFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* getWalletFundOptionsSaga(): Generator<any, any, any> {
    try {
        const response = yield call(api, `${campaignWalletUrl}/fund/options`, httpRequest.GET, null);
        yield put(getWalletFundOptionsSuccess(response.data));
    } catch (error: any) {
        yield put(getWalletFundOptionsFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* adminCreditCampaignWalletSaga({ payload }: { payload: IAdminCreditWalletRequest }): Generator<any, any, any> {
    try {
        const response = yield call(api, campaignWalletAdminCreditUrl, httpRequest.POST, payload);
        const data = response?.data ?? response;
        yield put(adminCreditCampaignWalletSuccess(data));
        yield call(
            showToastMessage,
            `Credited ${((data?.transaction?.amount_cents ?? 0) / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })} to campaign wallet`,
            'success',
        );
    } catch (error: any) {
        SentryCapture(error);
        yield put(adminCreditCampaignWalletFail(error));
        yield call(globalErrorHandler, error);
    }
}

function normalizeFundWalletResponse(raw: unknown): Record<string, unknown> {
    if (!raw || typeof raw !== 'object') return {};
    const r = raw as Record<string, unknown>;
    const inner = r.data;
    if (inner && typeof inner === 'object') return inner as Record<string, unknown>;
    return r;
}

function* fundWalletSaga({ payload, resolve, reject }: FundWalletAction): Generator<any, any, any> {
    try {
        const response = yield call(api, `${campaignWalletUrl}/fund`, httpRequest.POST, payload);
        const data = normalizeFundWalletResponse(response);
        if (!data.provider && data.authorization_url) {
            data.provider = data.tx_ref && !data.access_code ? 'flutterwave' : 'paystack';
        }
        if (!data.provider && data.clientSecret) data.provider = 'stripe';
        yield put(fundWalletSuccess(data as any));
        if (resolve) resolve(data);
    } catch (error: any) {
        yield put(fundWalletFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* verifyWalletFundSaga({ payload, resolve, reject }: VerifyWalletFundAction): Generator<any, any, any> {
    try {
        const useFlutterwave =
            payload.provider === 'flutterwave' || Boolean(payload.transaction_id) || Boolean(payload.tx_ref);
        const url = useFlutterwave ? campaignWalletFundVerifyFlutterwaveUrl : campaignWalletFundVerifyUrl;
        const body: Record<string, string> = {};
        if (payload.transaction_id) body.transaction_id = payload.transaction_id;
        if (payload.tx_ref) body.tx_ref = payload.tx_ref;
        if (payload.reference) body.reference = payload.reference;
        const response = yield call(api, url, httpRequest.POST, body);
        const envelope = response?.data ?? response;
        const data = envelope?.data ?? envelope;
        if (resolve) resolve(data);
    } catch (error: any) {
        if (reject) reject(error);
        throw error;
    }
}

function* campaignWalletDepositCompletedSaga({
    payload,
}: SagaAction<ICampaignWalletDepositSocketPayload>): Generator<any, any, any> {
    const credited =
        payload.transaction?.amount_usd != null
            ? `$${payload.transaction.amount_usd.toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              })}`
            : payload.transaction?.amount_cents != null
            ? `$${(payload.transaction.amount_cents / 100).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              })}`
            : null;
    yield put(getWalletDashboard());
    yield call(
        showToastMessage,
        credited ? `${credited} USD added to your wallet` : 'Wallet deposit completed',
        'success',
    );
}

function* lockEscrowSaga({ payload, resolve, reject }: EscrowAction): Generator<any, any, any> {
    try {
        const response = yield call(api, `${campaignWalletUrl}/escrow`, httpRequest.POST, payload);
        yield put(lockEscrowSuccess(response.data.escrow));
        yield call(showToastMessage, 'Funds locked in escrow', 'success');
        yield put(getOffsiteCampaignDetails({ campaignId: payload.campaign_id, asBrandHost: true }));
        if (resolve) resolve(response.data.escrow);
    } catch (error: any) {
        yield put(lockEscrowFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* releaseEscrowSaga({ payload, resolve, reject }: ReleaseEscrowAction): Generator<any, any, any> {
    try {
        const response = yield call(api, `${campaignWalletUrl}/escrow/${payload}/release`, httpRequest.POST, null);
        yield put(releaseEscrowSuccess(response.data.escrow));
        yield call(showToastMessage, 'Escrow released', 'success');
        if (resolve) resolve(response.data.escrow);
    } catch (error: any) {
        yield put(releaseEscrowFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* payoutEscrowSaga({ payload, resolve, reject }: PayoutAction): Generator<any, any, any> {
    try {
        const response = yield call(api, `${campaignWalletUrl}/escrow/${payload.campaignId}/payout`, httpRequest.POST, {
            amount_cents: payload.amount_cents,
            ...(payload.participant_id && { participant_id: payload.participant_id }),
        });
        yield put(payoutEscrowSuccess(response.data.escrow));
        yield call(showToastMessage, 'Payout processed', 'success');
        if (payload.participant_id) {
            yield put(
                getCampaignWorkspace({
                    perspective: 'brand',
                    participantId: payload.participant_id,
                    messagesPage: 1,
                    messagesLimit: 20,
                    appendMessages: false,
                    silentRefresh: true,
                }),
            );
        }
        if (resolve) resolve(response.data.escrow);
    } catch (error: any) {
        yield put(payoutEscrowFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* payoutEscrowRoundSaga({ payload }: ReturnType<typeof payoutEscrowRound>): Generator<any, any, any> {
    try {
        yield call(api, `${campaignWalletUrl}/escrow/${payload.campaignId}/payout-round`, httpRequest.POST, {
            participant_id: payload.participant_id,
            round_id: payload.round_id,
        });
        yield put(payoutEscrowRoundSuccess());
        yield call(showToastMessage, 'Round payment released', 'success');
        yield put(
            getCampaignWorkspace({
                perspective: 'brand',
                participantId: payload.participant_id,
                messagesPage: 1,
                messagesLimit: 20,
                appendMessages: false,
                silentRefresh: true,
            }),
        );
    } catch (error: any) {
        yield put(payoutEscrowRoundFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* updateAutoReloadSaga({ payload }: { payload: IUpdateAutoReloadPayload }): Generator<any, any, any> {
    try {
        const response = yield call(api, `${campaignWalletUrl}/auto-reload`, httpRequest.PATCH, payload);
        yield put(updateAutoReloadSuccess(response.data.wallet));
        yield call(showToastMessage, 'Auto-reload settings updated', 'success');
    } catch (error: any) {
        yield put(updateAutoReloadFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* getWalletTransactionsSaga({ payload }: { payload: IGetTransactionsPayload }): Generator<any, any, any> {
    try {
        const params = new URLSearchParams();
        if (payload.page) params.append('page', String(payload.page));
        if (payload.limit) params.append('limit', String(payload.limit));
        if (payload.type) params.append('type', payload.type);
        if (payload.status) params.append('status', payload.status);
        const qs = params.toString();
        const url = qs ? `${campaignWalletUrl}/transactions?${qs}` : `${campaignWalletUrl}/transactions`;
        const response = yield call(api, url, httpRequest.GET, null);
        yield put(getWalletTransactionsSuccess(response.data.transactions));
    } catch (error: any) {
        SentryCapture(error);
        yield put(getWalletTransactionsFail(error));
        yield call(globalErrorHandler, error);
    }
}

// ── Action Interfaces ───────────────────────────────────────────────────

interface AddBrandAction extends Action {
    payload: any;
    resolve: (response: any) => void;
    reject: (reason: any) => void;
}

interface UpdateBrandAction extends Action {
    payload: any;
    resolve: (response: any) => void;
    reject: (reason: any) => void;
}

interface BrandSocialLoginAction extends Action {
    payload: IBrandSocialLoginPayload;
    resolve: (response: any) => void;
    reject: (reason: any) => void;
}

interface FundWalletAction extends Action {
    payload: IFundWalletPayload;
    resolve: (response: any) => void;
    reject: (reason: any) => void;
}

interface VerifyWalletFundAction extends Action {
    payload: IVerifyWalletFundPayload;
    resolve: (response: any) => void;
    reject: (reason: any) => void;
}

interface EscrowAction extends Action {
    payload: IEscrowPayload;
    resolve: (response: any) => void;
    reject: (reason: any) => void;
}

interface ReleaseEscrowAction extends Action {
    payload: string;
    resolve: (response: any) => void;
    reject: (reason: any) => void;
}

interface PayoutAction extends Action {
    payload: IPayoutPayload;
    resolve: (response: any) => void;
    reject: (reason: any) => void;
}

interface GetBuzzProfileAction extends Action {
    payload: IGetBuzzBridgeProfile;
    resolve: (response: IBuzzBridgeProfileResponse) => Promise<void>;
    reject: (reason: any) => Promise<void>;
}

interface UpdateBuzzProfileAction extends Action {
    payload: IGenericDocumentModifier;
}

interface SaveManualInstagramLinkAction extends Action {
    payload: ISaveManualInstagramLinkPayload;
    resolve?: (influencerId: string) => void;
    reject?: (reason: unknown) => void;
}

interface CreateBrandSocialLinkAction extends Action {
    payload: ICreateBrandSocialLinkPayload;
    resolve?: (link: IBrandSocialProfile) => void;
    reject?: (reason: unknown) => void;
}

interface UpdateBrandSocialLinkAction extends Action {
    payload: IUpdateBrandSocialLinkPayload;
    resolve?: (link: IBrandSocialProfile) => void;
    reject?: (reason: unknown) => void;
}

interface RequestToJoinCampaignAction extends Action {
    payload: IRequestToJoinCampaign;
    resolve?: (value: unknown) => void;
    reject?: (reason: unknown) => void;
}

// ── Root Saga ───────────────────────────────────────────────────────────

type SagaAction<P = any> = Action & { payload: P };

export default function* buzzbridgeSaga(): Generator<any, any, any> {
    yield all([
        takeLatest<SagaAction>(types.JOIN_PROGRAM, joinProgramSaga),
        takeLatest<SagaAction<ICreateCampaignPayload>>(types.CREATE_OFFSITE_CAMPAIGN, createOffsiteCampaignSaga),
        takeLatest<RequestToJoinCampaignAction>(types.REQUEST_TO_JOIN_CAMPAIGN, requestToJoinCampaignSaga),
        takeLatest<SagaAction<IApproveJoinRequest>>(
            types.APPROVE_CAMPAIGN_JOIN_REQUEST,
            approveCampaignJoinRequestSaga,
        ),
        takeLatest<SagaAction<IBulkApproveJoinRequests>>(
            types.BULK_APPROVE_CAMPAIGN_JOIN_REQUESTS,
            bulkApproveCampaignJoinRequestsSaga,
        ),
        takeLatest<SagaAction<IBulkRejectJoinRequests>>(
            types.BULK_REJECT_CAMPAIGN_JOIN_REQUESTS,
            bulkRejectCampaignJoinRequestsSaga,
        ),
        takeLatest<SagaAction<IBulkRescindParticipants>>(
            types.BULK_RESCIND_CAMPAIGN_PARTICIPANTS,
            bulkRescindCampaignParticipantsSaga,
        ),
        takeLatest<SagaAction<IRejectJoinRequest>>(types.REJECT_CAMPAIGN_JOIN_REQUEST, rejectCampaignJoinRequestSaga),
        takeLatest<SagaAction<IGetCampaignPendingInvites>>(
            types.GET_CAMPAIGN_PENDING_INVITES,
            getCampaignPendingInvitesSaga,
        ),
        takeLatest<SagaAction<ICancelCampaignInvite>>(types.CANCEL_CAMPAIGN_INVITE, cancelCampaignInviteSaga),
        takeLatest<SagaAction<IRescindParticipantApproval>>(
            types.RESCIND_CAMPAIGN_PARTICIPANT_APPROVAL,
            rescindCampaignParticipantApprovalSaga,
        ),
        takeLatest<SagaAction>(types.GET_OFFSITE_CAMPAIGN_DETAILS, getOffsiteCampaignDetailsSaga),
        takeLatest<SagaAction>(types.GET_CAMPAIGN_JOB_DETAILS, getCampaignJobDetailsSaga),
        takeLatest<SagaAction<{ participantId: string }>>(
            types.GET_CAMPAIGN_APPLICATION_REVIEW,
            getCampaignApplicationReviewSaga,
        ),
        takeLatest<SagaAction<IGetCampaignWorkspacePayload>>(types.GET_CAMPAIGN_WORKSPACE, getCampaignWorkspaceSaga),
        takeLatest<SagaAction<ISendCampaignThreadMessagePayload>>(
            types.SEND_CAMPAIGN_THREAD_MESSAGE,
            sendCampaignThreadMessageSaga,
        ),
        takeLatest<SagaAction<IBroadcastCampaignParticipantMessagePayload>>(
            types.BROADCAST_CAMPAIGN_PARTICIPANT_MESSAGE,
            broadcastCampaignParticipantMessageSaga,
        ),
        takeLatest<SagaAction<IListCampaignThreadMessagesPayload>>(
            types.LIST_CAMPAIGN_THREAD_MESSAGES,
            listCampaignThreadMessagesSaga,
        ),
        takeLatest<SagaAction<IPatchCampaignThreadMessagePayload>>(
            types.PATCH_CAMPAIGN_THREAD_MESSAGE,
            patchCampaignThreadMessageSaga,
        ),
        takeLatest<SagaAction<IDeleteCampaignThreadMessagePayload>>(
            types.DELETE_CAMPAIGN_THREAD_MESSAGE,
            deleteCampaignThreadMessageSaga,
        ),
        takeLatest<SagaAction<IMarkCampaignThreadReadPayload>>(
            types.MARK_CAMPAIGN_THREAD_READ,
            markCampaignThreadReadSaga,
        ),
        takeLatest<SagaAction<IMarkAllCampaignThreadsReadPayload>>(
            types.MARK_ALL_CAMPAIGN_THREADS_READ,
            markAllCampaignThreadsReadSaga,
        ),
        takeLatest<SagaAction<ISubmitParticipantWorkPayload>>(types.SUBMIT_PARTICIPANT_WORK, submitParticipantWorkSaga),
        takeLatest<SagaAction<ISubmitLiveUrlPayload>>(types.SUBMIT_LIVE_URL, submitLiveUrlSaga),
        takeLatest<SagaAction<IRetrySubmissionProcessingPayload>>(
            types.RETRY_SUBMISSION_PROCESSING,
            retrySubmissionProcessingSaga,
        ),
        takeLatest<SagaAction<IMarkSharedPayload>>(types.MARK_SHARED, markSharedSaga),
        takeLatest<SagaAction<IRequestLiveUrlRevisionPayload>>(
            types.REQUEST_LIVE_URL_REVISION,
            requestLiveUrlRevisionSaga,
        ),
        takeLatest<SagaAction<ISaveBrandReviewPayload>>(types.SAVE_BRAND_REVIEW, saveBrandReviewSaga),
        takeLatest(types.FETCH_BRAND_REVIEWS_PAGE as any, fetchBrandReviewsPageSaga),
        takeLatest<SagaAction<ISaveInfluencerReviewPayload>>(types.SAVE_INFLUENCER_REVIEW, saveInfluencerReviewSaga),
        takeLatest<SagaAction<IGetCampaigns>>(types.MANAGE_OFFSITE_CAMPAIGNS, manageOffsiteCampaignsSaga),
        takeLatest<SagaAction<IUpdateCampaignPayload>>(types.UPDATE_OFFSITE_CAMPAIGN, updateOffsiteCampaignSaga),
        takeLatest<SagaAction>(types.DELETE_OFFSITE_CAMPAIGN, deleteOffsiteCampaignSaga),
        takeLatest<SagaAction>(types.UPDATE_CAMPAIGN_STATUS, updateCampaignStatusSaga),
        takeLatest<SagaAction<IGetBrands>>(types.GET_BRANDS, getBrandsSaga),
        takeLatest<SagaAction<string>>(types.GET_BRAND, getBrandSaga),
        takeLatest<SagaAction<IGetHostDashboard>>(types.GET_HOST_DASHBOARD, getHostDashboardSaga),
        takeLatest<AddBrandAction>(types.ADD_BRAND, addBrandSaga),
        takeLatest<UpdateBrandAction>(types.UPDATE_BRAND, updateBrandSaga),
        takeLatest<SagaAction<IGenericDocumentModifier>>(types.DELETE_BRAND, deleteBrandSaga),
        takeLatest<SagaAction>(types.REQUEST_DELIEVERABLE_UPDATE, requestDeliverableUpdateSaga),
        takeLatest<SagaAction>(types.BULK_REQUEST_REVISION, bulkRequestRevisionSaga),
        takeLatest<SagaAction>(types.RELAUNCH_CAMPAIGN, relaunchCampaignSaga),
        takeLatest<SagaAction>(types.SEND_CAMPAIGN_MESSAGE, inviteInfluencerSaga),
        takeLatest<SagaAction>(types.DELETE_CAMPAIGN_MESSAGE, deleteCampaignMessageSaga),
        takeLatest<SagaAction>(types.UPDATE_CAMPAIGN_MESSAGE, updateCampaignMessageSaga),
        takeLatest<SagaAction>(types.APPROVE_DELIVERABLE_SUBMISSION, approveDeliverableSubmissionSaga),
        takeLatest<SagaAction>(types.SCHEDULE_POST, schedulePostSaga),
        takeLatest<SagaAction>(types.UPLOAD_DELIVERABLE, uploadDeliverableSaga),
        takeLatest<GetBuzzProfileAction>(types.GET_BUZZBRIDGE_PROFILE, getBuzzProfile),
        takeLatest<SagaAction<IGetPublicInfluencerProfilePayload>>(
            types.GET_PUBLIC_INFLUENCER_PROFILE,
            getPublicInfluencerProfileSaga,
        ),
        takeLatest<UpdateBuzzProfileAction>(types.UPDATE_BUZZBRIDGE_PROFILE, updateBuzzProfile),
        takeLatest<SaveManualInstagramLinkAction>(types.SAVE_MANUAL_INSTAGRAM_LINK, saveManualInstagramLinkSaga),
        takeLatest<BrandSocialLoginAction>(types.BRAND_SOCIAL_LOGIN, brandSocialLoginSaga),
        takeLatest<CreateBrandSocialLinkAction>(types.CREATE_BRAND_SOCIAL_LINK, createBrandSocialLinkSaga),
        takeLatest<UpdateBrandSocialLinkAction>(types.UPDATE_BRAND_SOCIAL_LINK, updateBrandSocialLinkSaga),
        // Campaign Wallet
        takeLatest<SagaAction>(types.GET_WALLET_DASHBOARD, getWalletDashboardSaga),
        takeLatest<SagaAction>(types.GET_COMMISSION_WALLET, getCommissionWalletSaga),
        takeLatest<SagaAction>(types.CASH_OUT_COMMISSION_WALLET, cashOutCommissionWalletSaga),
        takeLatest<SagaAction>(types.GET_WALLET_FUND_OPTIONS, getWalletFundOptionsSaga),
        takeLatest<SagaAction<IAdminCreditWalletRequest>>(
            types.ADMIN_CREDIT_CAMPAIGN_WALLET,
            adminCreditCampaignWalletSaga,
        ),
        takeLatest<FundWalletAction>(types.FUND_WALLET, fundWalletSaga),
        takeLatest<VerifyWalletFundAction>(types.VERIFY_WALLET_FUND, verifyWalletFundSaga),
        takeLatest<SagaAction<ICampaignWalletDepositSocketPayload>>(
            types.CAMPAIGN_WALLET_DEPOSIT_COMPLETED,
            campaignWalletDepositCompletedSaga,
        ),
        takeLatest<EscrowAction>(types.LOCK_ESCROW, lockEscrowSaga),
        takeLatest<ReleaseEscrowAction>(types.RELEASE_ESCROW, releaseEscrowSaga),
        takeLatest<PayoutAction>(types.PAYOUT_ESCROW, payoutEscrowSaga),
        takeLatest(types.PAYOUT_ESCROW_ROUND, payoutEscrowRoundSaga),
        takeLatest<SagaAction<IUpdateAutoReloadPayload>>(types.UPDATE_AUTO_RELOAD, updateAutoReloadSaga),
        takeLatest<SagaAction<IGetTransactionsPayload>>(types.GET_WALLET_TRANSACTIONS, getWalletTransactionsSaga),
        takeLatest<SagaAction<{ participantId: string }>>(types.WITHDRAW_FROM_CAMPAIGN, withdrawFromCampaignSaga),
        takeLatest<SagaAction<{ participantId: string; requestedDays: number; reason?: string; round_id?: string }>>(
            types.REQUEST_DELIVERY_EXTENSION,
            requestDeliveryExtensionSaga,
        ),
        takeLatest<SagaAction<{ participantId: string; requestId: string }>>(
            types.APPROVE_DELIVERY_EXTENSION,
            approveDeliveryExtensionSaga,
        ),
        takeLatest<SagaAction<{ participantId: string; requestId: string }>>(
            types.REJECT_DELIVERY_EXTENSION,
            rejectDeliveryExtensionSaga,
        ),
        takeLatest<SagaAction<{ participantId: string; roundId?: string | null }>>(
            types.OPEN_LIVE_LINK_WINDOW,
            openLiveLinkWindowSaga,
        ),
        campaignReportWatchers(),
        influencerPrelinkSaga(),
    ]);
}
